

const product_img_menu = [
    {
        id: 1,
        category: "UTRUSTNING",
        product_name: "LJUD",
        thumb: "./images/1.png",
        onclick: "ljud/ljudsubmeny",
        level: 2,
    },
    {
        id: 2,
        category: "UTRUSTNING",
        product_name: "LJUS",
        thumb: "./images/ljus/ljus.png",
        level: 2
    },
    {
        id: 3,
        category: "UTRUSTNING",
        product_name: "KABEL",
        thumb: "./images/kabel.png",
        level: 2
    },
    {
        id: 4,
        category: "UTRUSTNING",
        product_name: "RIGGING",
        thumb: "./images//rigging/rigging.png",
        level: 2
    },
    {
        id: 5,
        category: "UTRUSTNING",
        product_name: "ÖVRIGT",
        thumb: "./images/no_img.png",
        level: 2
    },
// LJUD
    {
        id: 10,
        category: "LJUD",
        product_name: "LINEARRAY",
        thumb: "./images/ljud/Linearray.png",
        level: 3
    },
    {
        id: 11,
        category: "LJUD",
        product_name: "HÖGTALARE",
        thumb: "./images/ljud/speakers.png",
        level: 3
    },
    {
        id: 12,
        category: "LJUD",
        product_name: "Mixerbord",
        thumb: "./images/ljud/mixerbord.png",
        level: 3
    },
    {
        id: 13,
        category: "LJUD",
        product_name: "Signalhantering",
        thumb: "./images/no_img.png",
        level: 3
    },
    {
        id: 14,
        category: "LJUD",
        product_name: "DJ Utrustning",
        thumb: "./images/ljud/djutrustning.png",
        level: 3
    },
    {
        id: 15,
        category: "LJUD",
        product_name: "Mikrofoner",
        thumb: "./images/ljud/mikrofon.png",
        level: 3
    },
    {
        id: 16,
        category: "LJUD",
        product_name: "Trådlösa system",
        thumb: "./images/ljud/wl.png",
        level: 3
    },
    {
        id: 17,
        category: "LJUD",
        product_name: "Lineboxar",
        thumb: "./images/no_img.png",
        level: 3
    },
    {
        id: 18,
        category: "LJUD",
        product_name: "Ljudstativ",
        thumb: "./images/no_img.png",
        level: 3
    },
    {
        id: 19,
        category: "LJUD",
        product_name: "Ljudverktyg",
        thumb: "./images/ljud/soundmeter.png",
        level: 3
    },

//LJUS
    {
        id: 21,
        category: "LJUS",
        product_name: "Ljusbord",
        thumb: "./images/ljus/ljusbord.png",
        level: 3
    },{
        id: 22,
        category: "LJUS",
        product_name: "DMX distribution",
        thumb: "./images/ljus/signalhantering.png",
        level: 3
    },
    {
        id: 23,
        category: "LJUS",
        product_name: "Moving Heads",
        thumb: "./images/ljus/movingheads.png",
        level: 3
    },
    {
        id: 24,
        category: "LJUS",
        product_name: "Ramper",
        thumb: "./images/ljus/ledbar.png",
        level: 3
    },
   
    {
        id: 25,
        category: "LJUS",
        product_name: "LED",
        thumb: "./images/ljus/ledpar.png",
        level: 3
    },
    {
        id: 26,
        category: "LJUS",
        product_name: "BATTERILAMPOR",
        thumb: "./images/ljus/batterylamps.png",
        level: 3
    },
    {
        id: 27,
        category: "LJUS",
        product_name: "DISCOEFFEKTER",
        thumb: "./images/ljus/smoke.png",
        level: 3
    },
    {
        id: 28,
        category: "LJUS",
        product_name: "Rökmaskiner",
        thumb: "./images/ljus/smoke.png",
        level: 3
    },
    {
        id: 29,
        category: "LJUS",
        product_name: "Övrigt Ljus",
        thumb: "./images/ljus/effects.png",
        level: 3
    },

// KABEL
    {
        id: 51,
        category: "KABEL",
        product_name: "Elcentraler",
        thumb: "./images/kabel/pdu.png",
        level: 3
    },
    {
        id: 52,
        category: "KABEL",
        product_name: "3-Fas kabel",
        thumb: "./images/no_img.png",
        level: 3
    },
    {
        id: 53,
        category: "KABEL",
        product_name: "Strömkabel",
        thumb: "./images/no_img.png",
        level: 3
    },
    {
        id: 54,
        category: "KABEL",
        product_name: "Ljudkabel",
        thumb: "./images/no_img.png",
        level: 3
    },
    {
        id: 55,
        category: "KABEL",
        product_name: "DMX kabel",
        thumb: "./images/no_img.png",
        level: 3
    },
    {
        id: 56,
        category: "KABEL",
        product_name: "Nätverkskabel",
        thumb: "./images/no_img.png",
        level: 3
    },
    {
        id: 57,
        category: "KABEL",
        product_name: "BNC kabel",
        thumb: "./images/no_img.png",
        level: 3
    },
    {
        id: 58,
        category: "KABEL",
        product_name: "Övrig kabel",
        thumb: "./images/no_img.png",
        level: 3
    },
    {
        id: 59,
        category: "KABEL",
        product_name: "Kabelskydd",
        thumb: "./images/kabel/kabelskydd.png",
        level: 3
    },

// Rigging
{
    id: 60,
    category: "RIGGING",
    product_name: "Lyftredskap",
    thumb: "./images/no_img.png",
    level: 3
},
{
    id: 61,
    category: "RIGGING",
    product_name: "F31 Truss",
    thumb: "./images/rigging/F31050B.png",
    level: 3
},
{
    id: 62,
    category: "RIGGING",
    product_name: "F32 Truss",
    thumb: "./images/rigging/F32050.png",
    level: 3
},
{
    id: 64,
    category: "RIGGING",
    product_name: "F34 Truss",
    thumb: "./images/rigging/F34050.png",
    level: 3
},
{
    id: 65,
    category: "RIGGING",
    product_name: "Ground Support",
    thumb: "./images/rigging/F34tower.png",
    level: 3
},
{
    id: 66,
    category: "RIGGING",
    product_name: "Specialdelar",
    thumb: "./images/no_img.png",
    level: 3
},
{
    id: 67,
    category: "RIGGING",
    product_name: "Övrig Rigging",
    thumb: "./images/rigging/rigg.png",
    level: 3
},

// Övrigt
{
    id: 81,
    category: "ÖVRIGT",
    product_name: "Nätverk",
    thumb: "./images/diverse/network.png",
    level: 3
},
{
    id: 82,
    category: "ÖVRIGT",
    product_name: "Kom-radios",
    thumb: "./images/diverse/komradio.png",
    level: 3
},
{
    id: 83,
    category: "ÖVRIGT",
    product_name: "Tyger",
    thumb: "./images/no_img.png",
    level: 3
},
{
    id: 95,
    category: "TILL SALU",
    product_name: "Begagnat Ljud",
    thumb: "./images/no_img.png",
    level: 3
},


// LJUD

// Line Array
    
    {
            id: 10001,
            level: 4,
            category: "LINEARRAY",
            product_name: "KOMPLETT SYSTEM",
            producer: "DB Technologies",
            artnr: "010-001",
             
            description:
              "Hur ett system ser ut beror på vad eventet kräver och hur lokalen ser ut. Systemet går både att monteras ståendes på basarna s.k. Ground stackat eller hängandes s.k. Flygandes. I båda fallen utgår man från flygramen. katMer information kommer.",
            
              all_lists:[
                {
                    list_data:" ",
                },
                {
                    list_data:"Systemet består i bland annat av:",
                },
                {
                    list_data:" ",
                },
                {
                    list_data:"DRK-10 Flygram",
                },
                {
                    list_data:"DVA T12 Line Array modul",
                },
                {
                    list_data:"DVA T8 Line Array modul",
                },
                {
                    list_data:"DVA S10 basar 1 x 18\" (Går att flyga)",
                },
                {
                    list_data:"DVA S30n 2 x 18\" basar",
                },
                {
                    list_data:"RDnet Controller",
                },
 
 
            ],
    
            featured: "true",
            
         //gallery images
             thumb: "./images/ljud/komplete_system.png",
            
             gallery_img:[
                {
                    img:"./images/ljud/dvat12_1.png",
                },
                {
                    img:"./images/ljud/dvat12back.png",
                },
                {
                    img:"./images/ljud/dvat12case.png",
                },
               
            ] ,
    
             // technical
             dimension:'Beror på systemet',
             vikt_1:'Beror på systemet',
    
           // all cases
           all_cases:[ 
            {
                case_info:'Flygramar, handspel kabel m.m.',
                vikt_2:"70 kg",
                storlek:"1200 x 600 x 600 cm",
            },
            {
                case_info:'För 2 st DVA T12',
                vikt_2:"76 kg",
                storlek:"800 x 600 x 1000 cm",
            },
            {
                case_info:'För 4 st DVA T8',
                vikt_2:"78 kg",
                storlek:"800 x 600 x 1000 cm",
            },
        
         ],
          
            // icons
            icons:[
                {
                    icon:"./images/icons/powercon.png",
                    hovertext:'PowerCon',
                },
                {
                    icon:"./images/icons/rdnet.png",
                    hovertext:'RDNet',
                },
                {
                    icon:"./images/icons/rj45.png",
                    hovertext:'RJ45',
                }
            ] ,
    
          // download
          downloadable_link:[
            {
                d_img:"./images/download.png",
                d_heading:"DVA T12 Manual",
                d_link:"./downloads/DVA T12.pdf"
            },
            {
                d_img:"./images/download.png",
                d_heading:"DVA T12 Datasheet",
                d_link:"./downloads/DVA T12 Datasheet.pdf"
            }
        ],
    },
    {
        id: 10-101,
        level: 4,
        category: "LINEARRAY",
        product_name: "DVA T12",
        producer: "DB Technologies",
        artnr: "010-101",

        description:
        "Aktiv Line Array-modul 12\"/6.5\"/1\", 1500 Watt RMS. DVA T12 är den större lådan i vårat Line Array system. Även om den ger mer kraft och har större räckvidd, och dess aktiva trevägsdelning gör den enkel att installera. Levereras i case med 2 st. Via inbyggda RDNet fås full kontroll över systemet från mixplatsen, därigenom blir det möjligt att reglera nivåer, konfigurera och välja olika presets, testning av individuella komponenter och se status över temperatur etc.",

        all_lists:[
            {
                list_data:"Speaker Type: 3-Way Active Line Array Module",
            },
            {
                list_data:"Frequency Response [-6dB]: 60 - 19.000 Hz",
            },
            {
                list_data:"Max SPL: 136 dB One Unit",
            },
            {
                list_data:"HF: 3x1\"",
            },
            {
                list_data:"Voice Coil HF: 1.4\"",
            },
            {
                list_data:"Directivity: 100x10° Single unit",
            },
            {
                list_data:"Horn: Integrated CD Horn",
            },
            {
                list_data:"MF: 2x 6.5\"",
            },
            {
                list_data:"Type: MF Neodymium, Sealed Basket, Phase plug, Horn loaded",
            },
            {
                list_data:"Voice Coil Mf: 2\"",
            },
            {
                list_data:"LF: 12\"",
            },
            {
                list_data:"Type LF: Neodymium",
            },
            {
                list_data:"Voice Coil LF: 3\"",
            },
            {
                list_data:"Amp technology: Digipro G2",
            },
            {
                list_data:"Amp Class: Class D",
            },
            {
                list_data:"HF Amp: 350 W",
            },
            {
                list_data:"MF Amp: 350 W",
            },
            {
                list_data:"LF Amp: 710 W",
            },
            {
                list_data:"Controller: DSP 56 bit",
            },
            {
                list_data:"System Presets: 8, HF/Low-mid correction",
            },
            {
                list_data:"Signal: 1 x XLR in, 1 x XLR out",
            },
            {
                list_data:"Network: RDnet RJ45 in/out",
            },
            {
                list_data:"Power: 1 x PowerCon in, 1 x PowerCon out",
            },
        ],

        featured: "true",
         //gallery images
         thumb: "./images/ljud/dvat12_1.png",
         gallery_img:[
            {
                img:"./images/ljud/dvat12_1.png",
            },
            {
                img:"./images/ljud/dvat12back.png",
            },
            {
                img:"./images/ljud/dvat12case.png",
            },
           
        ] ,

         // technical
         dimension:'58 x 38 x 43 cm',
         vikt_1:'30 kg',

       // all cases
       all_cases:[ 
        {
            case_info:'För 2 st DVA T12',
            vikt_2:"76 kg",
            storlek:"800 x 600 x 1000 cm",
        },
    
     ],
      
        // icons
        icons:[
            {
                icon:"./images/icons/powercon.png",
                hovertext:'PowerCon',
            },
            {
                icon:"./images/icons/xlr3polv4.png",
                hovertext:'XLR 3-pol',
            },
            {
                icon:"./images/icons/rdnet.png",
                hovertext:'RDNet',
            },
            {
                icon:"./images/icons/rj45.png",
                hovertext:'RJ45',
            }
        ] ,

      // download
      downloadable_link:[
        {
            d_img:"./images/download.png",
            d_heading:"DVA T12 Manual",
            d_link:"./downloads/DVA T12.pdf"
        },
        {
            d_img:"./images/download.png",
            d_heading:"DVA T12 Datasheet",
            d_link:"./downloads/DVA T12 Datasheet.pdf"
        }
    ],
    },
    {
        id: 10102,
        level: 4,
        category: "LINEARRAY",
        product_name: "DVA T8",
        producer: "DB Technologies",
        artnr: "010-102",


        description:
        "Aktiv Line Array-modul 8\"/6.5\"/1\", 700 Watt RMS. DVA T8 är den mindre lådan i vårat Line Array system, ofta använd som downfill. Även om den ger mer kraft och har större räckvidd, och dess aktiva trevägsdelning gör den enkel att installera. Levereras i case med 2 st. Via inbyggda RDNet fås full kontroll över systemet från mixplatsen, därigenom blir det möjligt att reglera nivåer, konfigurera och välja olika presets, testning av individuella komponenter och se status över temperatur etc.",


        all_lists:[
                {
                list_data:"Speaker Type: 3-Way Active Line Array Module",
                },
                {
                list_data:"Frequency Response [-6dB]: 60 - 18.000 Hz",
                },
                {
            list_data:"Max SPL: 132 dB One Unit",
        },
        {
            list_data:"HF: 2x1\"",
        },
        {
            list_data:"Voice Coil HF: 1.4\"",
        },
        {
            list_data:"Directivity: 100x15° Single unit",
        },
        {
            list_data:"MF: 1x 6.5\"",
        },
        {
            list_data:"Voice Coil Mf: 2\"",
        },
        {
            list_data:"LF: 8\"",
        },
        {
            list_data:"Voice Coil LF: 2.5\"",
        },
        {
            list_data:"Amp technology: Digipro G2",
        },
        {
            list_data:"Amp Class: Class D",
        },
        {
            list_data:"HF Amp: 175 W",
        },
        {
            list_data:"MF Amp: 175 W",
        },
        {
            list_data:"LF Amp: 350 W",
        },
        {
            list_data:"Controller: DSP 56 bit",
        },
        {
            list_data:"System Presets: 8, HF/Low-mid correction",
        },
        {
            list_data:"Signal: 1 x XLR in, 1 x XLR out",
        },
        {
            list_data:"Network: RDnet RJ45 in/out",
        },
        {
            list_data:"Power: 1 x PowerCon in, 1 x PowerCon out",
        },
    ],


    featured: "true",
     //gallery images
     thumb: "./images/ljud/dvat8.png",
     gallery_img:[
        {
            img:"./images/ljud/dvat8.png",
        },
        
       
    ] ,


     // technical
     dimension:'58 x 24 x 33 cm',
     vikt_1:'14,2 kg',


   // all cases
   all_cases:[
    {
        case_info:'För 2 st DVA T8',
        vikt_2:"60 kg",
        storlek:"800 x 600 x 700 cm",
    },

 ],
 
    // icons
    icons:[
        {
            icon:"./images/icons/powercon.png",
            hovertext:'PowerCon',
        },
        {
            icon:"./images/icons/xlr3polv4.png",
            hovertext:'XLR 3-pol',
        },
        {
            icon:"./images/icons/rdnet.png",
            hovertext:'RDNet',
        },
        {
            icon:"./images/icons/rj45.png",
            hovertext:'RJ45',
        }
    ] ,


  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"DVA T8 Manual",
        d_link:"./downloads/DVA T8.pdf"
    },
    {
        d_img:"./images/download.png",
        d_heading:"DVA T8 Datasheet",
        d_link:"./downloads/DVA T8 Datasheet.pdf"
    }
],
    },

    {
        id: 10122,
        artnr: "010-122",
        category: "LINEARRAY",
        product_name: "DVA S10",
        producer: "DB Technologies",
        thumb: "./images/ljud/dvas10.png",
        level: 4,
         // 
       description:
          "Line array speaker zoom range from narrow 6° beam to wide 50° wash, Uniform illumination of the light cone. Sophisticated fan management with three selectable modes: Silent, Max and Auto. Adjustable pan and tilt range with selectable start and end points. 4 Selectable dimmer curves. Adjustable PWM",
        image: "./images/ljud/dvats10.png",
        featured: "true",
         // technical
         dimension:'29 x 29 x 29 cm',
         vikt_1:'30 kg',

       // all cases
       all_cases:[ 
        {
            case_info:'För 4 st DVA T8',
            vikt_2:"76 kg",
            storlek:"800 x 600 x 1000 cm",
        },
        
     ],
    },
    {
        id: 10123,
        level: 4,
        category: "LINEARRAY",
        product_name: "DVA S30",
        producer: "DB Technologies",
        artnr: "010-123",


        description:
        "DVA S30N 2x18\"sub har en sofistikerad hybriddesign som kan sammanföra fördelarna med basreflex- och hornsystem i ett kompakt hölje, konstruerat för att återge låga frekvenser med höga ljudtrycksnivåer.",


        all_lists:[
         
            {
                list_data:"Active Bassreflex-Horn Subwoofer",
            },
            {
                list_data:"Frequency Response [-6dB]: 30 - 120 Hz",
            },
            {
                list_data:"Max SPL: 141 dB One Unit",
            },
            {
                list_data:"LF: 2x18\"",
            },
            {
                list_data:"Voice Coil LF: 4\"",
            },
            {
                list_data:"Amp technology: Digipro G2",
            },
            {
                list_data:"Amp Class: Class D",
            },
            {
                list_data:"LF Amp: 3000 W",
            },
            {
                list_data:"Controller: DSP 56 bit",
            },
            {
                list_data:"System Presets: X-over, Delay, Phase 0, 180",
            },
            {
                list_data:"Signal: 1 x XLR in, 1 x XLR out link, 1 x XLR Link Delayed",
            },
            {
                list_data:"Network: RDnet RJ45 in/out",
            },
            {
                list_data:"Power: 1 x PowerCon in",
            },
        ],


        featured: "true",
         //gallery images
         thumb: "./images/ljud/dvas30n.png",
         gallery_img:[
            {
                img:"./images/ljud/dvas30n.png",
            },
                   
        ] ,


         // technical
         dimension:'110 x 58 x 72 cm',
         vikt_1:'83 kg',


   
   
   
     
        // icons
        icons:[
            {
                icon:"./images/icons/powercon.png",
                hovertext:'PowerCon',
            },
            {
                icon:"./images/icons/xlr3polv4.png",
                hovertext:'XLR 3-pol',
            },
            {
                icon:"./images/icons/rdnet.png",
                hovertext:'RDNet',
            },
            {
                icon:"./images/icons/rj45.png",
                hovertext:'RJ45',
            }
        ] ,


      // download
      downloadable_link:[
        {
            d_img:"./images/download.png",
            d_heading:"DVA S30N Manual",
            d_link:"./downloads/DVA S30N.pdf"
        },
        {
            d_img:"./images/download.png",
            d_heading:"DVA S30N Datasheet",
            d_link:"./downloads/DVA S30N Datasheet.pdf"
        }
    ],
},

    
    {
        id: 10191,
        level: 4,
        category: "LINEARRAY",
        product_name: "DRK-10 Flygram",
        producer: "DB Technologies",
        artnr: "010-191",

        description:
        "DVAs flygram kan flyga upp till 16 st DVA T4 eller 3 st DVA S10. Ramen är väl balanserad och har flera fästpunkter för hur högtalarna under hängs och för rätt vinkling. Om de inte finns någon möjlighet att flyga högtalarna så kan man även använda ramen för s.k. ground stack.",

        all_lists:[
            
        ],

        featured: "true",
         //gallery images
         thumb: "./images/ljud/drk-10.png",
         gallery_img:[
            {
                img:"./images/ljud/drk-10.png",
            },
            
           
        ] ,

         // technical
         dimension:'58 x 38 x 43 cm',
         vikt_1:'30 kg',

       // all cases
       all_cases:[ 
       
    
     ],
      
        // icons
        icons:[
              ] ,

      // download
      downloadable_link:[
        {
            d_img:"./images/download.png",
            d_heading:"DVA T12 Manual",
            d_link:"./downloads/DVA T12.pdf"
        },
        {
            d_img:"./images/download.png",
            d_heading:"DVA T12 Datasheet",
            d_link:"./downloads/DVA T12 Datasheet.pdf"
        }
    ],
    },
    {
        id: 10195,
        artnr: "010-195",
        category: "LINEARRAY",
        product_name: "RDNet Controler 8",
        producer: "Db Technologies",
        thumb: "./images/ljud/rdnet8.png",
        level: 4
    },
    {
        id: 10199,
        artnr: "010-195",
        category: "LINEARRAY",
        product_name: "LineArray PSU",
        producer: "SLDRS",
        thumb: "./images/no_img.png",
        level: 4
    },
  
// Högtalare
   {
        id: 10101,
        artnr: "010-001",
        category: "HÖGTALARE",
        product_name: "Litet discopaket",
        producer: "DB Technologies",
        thumb: "./images/ljud/smallsoundpacage.png",
        level: 4,
        
         description:
        "Perfekt för dansgolv upp till 100 personer. Ett av våra mest uthyrda paket till bröllop och privata fester. Anledningen är att det låter otroligt bra och är enkelt att rigga. En person (även oerfarna) riggar och kopplar allt på drygt 15 minuter.",

        all_lists:[
            {
                list_data:"2 st DB Technologies REEVO 212",
            },
            {
                list_data:"2 st DB Technologies Sub918",
            },
            {
                list_data:"2 st König & Meyer Dansbandspinne",
            },
            {
                list_data:"2 st True1 kablar",
            },
            {
                list_data:"2 st Länkkabel True1 till apparatkabel",
            },
            {
                list_data:"4 st XLR kablar (Mikrofonkablar)",
            },
        ],
    },

    {
        id: 10002,
        artnr: "010-002",
        category: "HÖGTALARE",
        product_name: "Stort discopaket",
        producer: "DB Technologies",
        thumb: "./images/ljud/bigsound.png",
        level: 4,
    
         description:
        "Perfekt för lite större dansgolv. Samma som det mindre fast med fler basar för att få mer tryck. Beroende på hur mycket tryck man vill ha i basen kan man välja att ha 4 eller 6 basar. Systemet är lätt att montera och riggas på drygt 15 minuter av 2 personer",

        all_lists:[
            {
                list_data:"2 st DB Technologies REEVO 212",
            },
            {
                list_data:"4 eller 6 st DB Technologies Sub918",
            },
            {
                list_data:"2 st König & Meyer Korta Stativpinnar",
            },
            {
                list_data:"2 st True1 kablar",
            },
            {
                list_data:"2-4 st True1 1m länkkablar",
            },
            {
                list_data:"2 st Länkkabel True1 till apparatkabel",
            },
            {
                list_data:"x st XLR kablar (Mikrofonkablar)",
            },
        ],
    },
    {
        id: 10195,
        artnr: "010-555",
        category: "HÖGTALARE",
        product_name: "DVX D8HP",
        producer: "DB Technologies",
        level: 4,

        description:
        "Kompakt aktiv 2-vägs högtalare för tal, bakgrundsmusik och mindre PA-system. Fungerar även som scenmonitor.",

        all_lists:[
            {
                list_data:"Högtalartyp: Aktiv 2-vägs högtalare",
            },
            {
                list_data:"Frekvensomfång: [-10dB] 75 - 20000 Hz",
            },
            {
                list_data:"Max SPL: 125 dB",
            },
            {
                list_data:"Förstärkare: Digipro G2 med SMPS",
            },
            {
                list_data:"Förstärkarklass: Klass D",
            },
            {
                list_data:"RMS-effekt: 400 W",
            },
            {
                list_data:"Toppeffekt: 800 W",
            },
            {
                list_data:"Bashögtalare: 8\"",
            },
            {
                list_data:"Diskanthögtalare: 1\" på vridbart CD-horn 90°x70°",
            },
            {
                list_data:"Styrenhet: DSP 24 bit/48 kHz",
            },
            {
                list_data:"Ingång: 1x XLR + 1x 6,3mm Jack, balanserad",
            },
            {
                list_data:"Flygfästen: 10x M8 + 2x quick release",
            },
            {
                list_data:"Stativfäste: 36 mm",
            },
        ],

        //gallery images
        thumb: "./images/ljud/dvx8.png",
        gallery_img:[
            {
                img:"./images/ljud/dvx8.png",
            },
        ] ,

        // technical
        dimension:'250 x 425 x 260 cm',
        vikt_1:'9,7 kg',

        // icons
        icons:[
            {
                icon:"./images/icons/apparat.png",
                hovertext:'Apparatkabel',
            },
            {
                icon:"./images/icons/xlr3polv4.png",
                hovertext:'XLR 3-pol',
            },
        ] ,

        // download
        downloadable_link:[
            {
                d_img:"./images/download.png",
                d_heading:"DVX D8HP Manual",
                d_link:"./downloads/DVX D8HP Manual.pdf"
            },
            {
                d_img:"./images/download.png",
                d_heading:"DVX D8HP Datasheet",
                d_link:"./downloads/DVX D8HP Datasheet.pdf"
            }
        ],
    },
    {
        id: 11194,
        artnr: "010-555",
        category: "HÖGTALARE",
        product_name: "DVX D12HP",
        producer: "DB Technologies",
        level: 4,

        description:
        "Aktiv 2-vägs högtalare i 12\"/1,4\", lätt och kraftfull. Passar som FOH-högtalare för mindre/medelstora event eller som scenmonitor.",

        all_lists:[
            {
                list_data:"Högtalartyp: Aktiv 2-vägs högtalare",
            },
            {
                list_data:"Frekvensomfång: [-10dB] 55 - 20000 Hz",
            },
            {
                list_data:"Max SPL: 131 dB",
            },
            {
                list_data:"Förstärkare: Digipro G2 med SMPS",
            },
            {
                list_data:"Förstärkarklass: Klass D",
            },
            {
                list_data:"RMS-effekt: 700 W",
            },
            {
                list_data:"Toppeffekt: 1400 W",
            },
            {
                list_data:"Bashögtalare: 12\"",
            },
            {
                list_data:"Diskanthögtalare: 1,4\" på vridbart CD-horn 60°x40°",
            },
            {
                list_data:"Styrenhet: DSP 24 bit/48 kHz",
            },
            {
                list_data:"Ingång: 1x XLR + 1x 6,3mm Jack, balanserad",
            },
            {
                list_data:"Flygfästen: 6x M10 + 4x quick release",
            },
            {
                list_data:"Stativfäste: 36 mm",
            },
        ],

        //gallery images
        thumb: "./images/ljud/dvx12.png",
        gallery_img:[
            {
                img:"./images/ljud/dvx12.png",
            },
        ] ,

        // technical
        dimension:'370 x 625 x 395 cm',
        vikt_1:'27,5 kg',

        // icons
        icons:[
            {
                icon:"./images/icons/apparat.png",
                hovertext:'Apparatkabel',
            },
            {
                icon:"./images/icons/xlr3polv4.png",
                hovertext:'XLR 3-pol',
            },
        ] ,

        // download
        downloadable_link:[
            {
                d_img:"./images/download.png",
                d_heading:"DVX D12HP Manual",
                d_link:"./downloads/DVX D12HP Manual.pdf"
            },
            {
                d_img:"./images/download.png",
                d_heading:"DVX D12HP Datasheet",
                d_link:"./downloads/DVX D12HP Datasheet.pdf"
            }
        ],
    },
    {
        id: 10515,
        artnr: "010-515",
        category: "HÖGTALARE",
        product_name: "DVX D15",
        producer: "DB Technologies",
        level: 4,

        description:
        "Aktiv 2-vägs högtalare i 15\"/1,4\", full-range FOH-högtalare eller kraftfull trummonitor - punchig bas utan extra subwoofer.",

        all_lists:[
            {
                list_data:"Högtalartyp: Aktiv 2-vägs högtalare",
            },
            {
                list_data:"Frekvensomfång: [-10dB] 49 - 20000 Hz",
            },
            {
                list_data:"Frekvensomfång: [±3dB] 57 - 19000 Hz",
            },
            {
                list_data:"Max SPL: 132 dB",
            },
            {
                list_data:"Förstärkare: Digipro G2 med SMPS",
            },
            {
                list_data:"Förstärkarklass: Klass D",
            },
            {
                list_data:"RMS-effekt: 700 W",
            },
            {
                list_data:"Toppeffekt: 1400 W",
            },
            {
                list_data:"Bashögtalare: 15\"",
            },
            {
                list_data:"Diskanthögtalare: 1,4\" på vridbart CD-horn 60°x40°",
            },
            {
                list_data:"Styrenhet: DSP 24 bit/48 kHz",
            },
            {
                list_data:"Ingång: 1x XLR + 1x 6,3mm Jack, balanserad",
            },
            {
                list_data:"Flygfästen: 6x M10 + 4x quick release",
            },
            {
                list_data:"Stativfäste: 36 mm",
            },
        ],

        //gallery images
        thumb: "./images/ljud/dvx15.png",
        gallery_img:[
            {
                img:"./images/ljud/dvx15.png",
            },
        ] ,

        // technical
        dimension:'430 x 690 x 450 cm',
        vikt_1:'30,3 kg',

        // icons
        icons:[
            {
                icon:"./images/icons/apparat.png",
                hovertext:'Apparatkabel',
            },
            {
                icon:"./images/icons/xlr3polv4.png",
                hovertext:'XLR 3-pol',
            },
        ] ,

        // download
        downloadable_link:[
            {
                d_img:"./images/download.png",
                d_heading:"DVX D15 HP Manual",
                d_link:"./downloads/DVX D15 HP Manual.pdf"
            },
            {
                d_img:"./images/download.png",
                d_heading:"DVX D15 HP Datasheet",
                d_link:"./downloads/DVX D15 HP Datasheet.pdf"
            }
        ],
    },
    {
        id: 10602,
        artnr: "010-602",
        category: "HÖGTALARE",
        product_name: "Opera 405D",
        producer: "DB Technologies",
        level: 4,

        description:
        "Aktiv, biamplifierad 2-vägs högtalare i 15\"/1\". Populär bland mobila DJ:s och band - fungerar som FOH-högtalare eller golvmonitor.",

        all_lists:[
            {
                list_data:"Högtalartyp: Aktiv 2-vägs högtalare (biamp)",
            },
            {
                list_data:"Frekvensomfång: [-10dB] 49 - 20000 Hz",
            },
            {
                list_data:"Frekvensomfång: [±3dB] 58 - 19000 Hz",
            },
            {
                list_data:"Max SPL: 129 dB",
            },
            {
                list_data:"Förstärkare: Digipro",
            },
            {
                list_data:"Förstärkarklass: Klass D",
            },
            {
                list_data:"RMS-effekt: 300 W bas + 100 W diskant",
            },
            {
                list_data:"Programeffekt: 600 W",
            },
            {
                list_data:"Bashögtalare: 15\"",
            },
            {
                list_data:"Diskanthögtalare: 1\" på asymmetriskt CD-horn 80/65°x60°",
            },
            {
                list_data:"Styrenhet: DSP 24 bit/48 kHz, förinställningar Flat/Processed",
            },
            {
                list_data:"Ingång: 1x XLR (Mic/Line) + 1x 6,3mm Jack",
            },
            {
                list_data:"Stativfäste: 36 mm",
            },
        ],

        //gallery images
        thumb: "./images/ljud/opera.png",
        gallery_img:[
            {
                img:"./images/ljud/opera.png",
            },
        ] ,

        // technical
        dimension:'432 x 655 x 353 cm',
        vikt_1:'14,5 kg',

        // icons
        icons:[
            {
                icon:"./images/icons/apparat.png",
                hovertext:'Apparatkabel',
            },
            {
                icon:"./images/icons/xlr3polv4.png",
                hovertext:'XLR 3-pol',
            },
        ] ,

        // download
        downloadable_link:[
            {
                d_img:"./images/download.png",
                d_heading:"Opera 405D Manual",
                d_link:"./downloads/Opera 405D Manual.pdf"
            },
            {
                d_img:"./images/download.png",
                d_heading:"Opera 405D Datasheet",
                d_link:"./downloads/Opera 405D Datasheet.pdf"
            }
        ],
    },
    {
        id: 10601,
        level: 4,
        category: "HÖGTALARE",
        product_name: "Reevo 212",
        producer: "DB Technologies",
        artnr: "010-601",

        description:
        "Kraftfull, nästan 3-vägs aktiv högtalare med enastående ljudtryck och basåtergivning - idealisk för FOH och touring.",

        all_lists:[
            {
                list_data:"Högtalartyp: Quasi 3-vägs aktiv högtalare",
            },
            {
                list_data:"Frekvensomfång: [-10dB] 48 - 20000 Hz",
            },
            {
                list_data:"Max SPL: 133 dB",
            },
            {
                list_data:"Förstärkare: Digipro G2 med SMPS",
            },
            {
                list_data:"Förstärkarklass: Klass D",
            },
            {
                list_data:"RMS-effekt: 1050 W",
            },
            {
                list_data:"Toppeffekt: 2100 W",
            },
            {
                list_data:"Styrenhet: DSP 28/56 bitar",
            },
            {
                list_data:"AD/DA-omvandlare: 24 bit/48 KHz",
            },
            {
                list_data:"Ingång: 1x Combo (XLR/Jack 6,3 mm)",
            },
            {
                list_data:"Utgång: 1x XLR-hane (True link)",
            },
            {
                list_data:"Flygfästen: 2x M10 på ovansidan + 1x M10 på baksidan",
            },
            {
                list_data:"Stativfäste: 36 mm",
            },
            {
                list_data:"Power: 1 x Apparatkabel",
            },
        ],

        featured: "true",
         //gallery images
         thumb: "./images/ljud/reevo212.png",
         gallery_img:[
            {
                img:"./images/ljud/reevo212.png",
            },
            {
                img:"./images/ljud/reevo212_2.png",
            },
            {
                img:"./images/ljud/reevo212_3.png",
            },
           {
                img:"./images/ljud/reevo212_4.png",
            },
        ] ,

         // technical
         dimension:'345 x 690 x 376 cm',
         vikt_1:'20 kg',

              // icons
        icons:[
            {
                icon:"./images/icons/apparat.png",
                hovertext:'Apparatkabel',
            },
            {
                icon:"./images/icons/xlr3polv4.png",
                hovertext:'XLR 3-pol',
            },
            {
                icon:"./images/icons/fir.png",
                hovertext:'FIR filter',
            },
            
        ] ,

      // download
      downloadable_link:[
        {
            d_img:"./images/download.png",
            d_heading:"REEVO 212 Manual",
            d_link:"./downloads/reevo_212_manual.pdf"
        },
    ],
    },

    {
        id: 11198,
        artnr: "010-555",
        category: "HÖGTALARE",
        product_name: "DVX DM15",
        producer: "DB Technologies",
        level: 4,

        description:
        "Lågprofilerad aktiv 2-vägs scenmonitor i 15\"/1,4\". Levererar kraftfull bas utan extra subwoofer, för medelstora till stora scener.",

        all_lists:[
            {
                list_data:"Högtalartyp: Aktiv 2-vägs scenmonitor",
            },
            {
                list_data:"Frekvensomfång: [-10dB] 50 - 20000 Hz",
            },
            {
                list_data:"Frekvensomfång: [±3dB] 59 - 19000 Hz",
            },
            {
                list_data:"Max SPL: 132 dB",
            },
            {
                list_data:"Förstärkare: Digipro",
            },
            {
                list_data:"Förstärkarklass: Klass D",
            },
            {
                list_data:"RMS-effekt: 750 W",
            },
            {
                list_data:"Toppeffekt: 1500 W",
            },
            {
                list_data:"Bashögtalare: 15\" neodymium",
            },
            {
                list_data:"Diskanthögtalare: 1,4\" neodymium på vridbart CD-horn 60°x40°",
            },
            {
                list_data:"Styrenhet: DSP 24 bit/48 kHz med flera förinställningar",
            },
            {
                list_data:"Flygfästen: 6x M8",
            },
            {
                list_data:"Monitorvinklar: 35° och 55°",
            },
        ],

        //gallery images
        thumb: "./images/ljud/dvxdm15.png",
        gallery_img:[
            {
                img:"./images/ljud/dvxdm15.png",
            },
        ] ,

        // technical
        dimension:'734 x 338 x 442 cm',
        vikt_1:'21 kg',

        // icons
        icons:[
            {
                icon:"./images/icons/apparat.png",
                hovertext:'Apparatkabel',
            },
            {
                icon:"./images/icons/xlr3polv4.png",
                hovertext:'XLR 3-pol',
            },
        ] ,

        // download
        downloadable_link:[
            {
                d_img:"./images/download.png",
                d_heading:"DVX DM15 Manual",
                d_link:"./downloads/DVX DM15 Manual.pdf"
            },
            {
                d_img:"./images/download.png",
                d_heading:"DVX DM15 Datasheet",
                d_link:"./downloads/DVX DM15 Datasheet.pdf"
            }
        ],
    },
    {
        id: 10611,
        level: 4,
        category: "HÖGTALARE",
        product_name: "SUB918",
        producer: "DB Technologies",
        artnr: "010-611",

        description:
        "Aktiv bashögtalare (subwoofer) med 18\" element, 900 W RMS. SUB 918 är avsedd att förstärka och förlänga baslinjen i ett PA-system och ger ett djupt, fylligt och distortionsfritt bastryck. Kabinettet är kompakt och lätt att transportera med integrerade handtag, kan placeras stående eller liggande och har M20-fästen för montering av topphögtalare ovanpå. Via RDNet och Aurora Net-mjukvaran kan subwoofern fjärrstyras och övervakas i realtid tillsammans med andra RDNet-kompatibla dB Technologies-högtalare.",

        all_lists:[
            {
                list_data:"Högtalartyp: Aktiv subwoofer, bashögtalare",
            },
            {
                list_data:"Frekvensomfång [-10dB]: 42 - 110 Hz",
            },
            {
                list_data:"Max SPL: 134 dB",
            },
            {
                list_data:"Bashögtalare: 18\", 4\" svängspole",
            },
            {
                list_data:"Förstärkare: Digipro G3",
            },
            {
                list_data:"Förstärkarklass: Klass D",
            },
            {
                list_data:"RMS-effekt: 900 W",
            },
            {
                list_data:"Toppeffekt: 1800 W",
            },
            {
                list_data:"Delningsfrekvens: Ställbar 70 - 110 Hz",
            },
            {
                list_data:"Styrenhet: DSP 28/56 bitar, dämpning, polaritet, fördröjning upp till 4,5 ms",
            },
            {
                list_data:"Fjärrstyrning: RDNet + Aurora Net (Windows/Mac)",
            },
            {
                list_data:"Ingång: 1x XLR in",
            },
            {
                list_data:"Stativfäste: 2x M20 (topp och sida)",
            },
        ],

        featured: "true",
         //gallery images
         thumb: "./images/ljud/sub918.png",
         gallery_img:[
            {
                img:"./images/ljud/sub918.png",
            },
              {
                img:"./images/ljud/sub918_2.png",
            },
              {
                img:"./images/ljud/sub918_3.png",
            },
        ] ,

         // technical
         dimension:'720 x 530 x 690 cm',
         vikt_1:'41,8 kg',

    
        // icons
        icons:[
            {
                icon:"./images/icons/true1.png",
                hovertext:'True1 kontakt',
            },
            {
                icon:"./images/icons/xlr3polv4.png",
                hovertext:'XLR 3-pol',
            },
            {
                icon:"./images/icons/rdnet.png",
                hovertext:'RDNet',
            },
        ] ,

      // download
      downloadable_link:[
        {
            d_img:"./images/download.png",
            d_heading:"SUB918 Manual",
            d_link:"./downloads/SUB918 Manual.pdf"
        },
        {
            d_img:"./images/download.png",
            d_heading:"SUB918 Datasheet",
            d_link:"./downloads/SUB918 Datasheet.pdf"
        }
    ],
    },



    // Mixerbord
 {
        id: 11201,
        category: "Mixerbord",
        product_name: "CQ18T",
        level: 4,
        producer: "Allen & Heath",
        artnr: "011-201",
        description:
          "CQ-18T är en ultrakompakt digitalmixer designad för att användas lokalt med sin inbyggda pekskärm och fysiska kontroller, på distans med hjälp av dess inbyggda WiFi eller genom anslutning till en trådbunden eller trådlöst nätverk. Byggd på en 96kHz processor, den är rik på anslutningsmöjligheter med Bluetooth, trådlösa alternativ, SD- och USB-ljudinspelning och uppspelning. Med fokus på hastighet och användarvänlighet. ",
          
          all_lists:[
            {
                list_data: "16 Mic/Line-förförstärkare 8x XLR + 8x XLR / TRS Combi",
            },
            {
                list_data:"Balanserad stereo linjeingång, 2x TRS",
            },
            {
                list_data:"Main LR, 2x XLR",
            },
            {
                list_data:"6 x monitormixar, 6x TRS ",
            },
{
                list_data:"2x tilldelbara hörlursutgångar, 2x 6,35 mm TRS",
            },
{
                list_data:"24x22 USB-B-gränssnitt",
            },
{
                list_data:"24x22 SD-inspelning/uppspelning",
            },
{
                list_data:"Stereo USB-inspelning/uppspelning med dedikerad ingångskanal Stereo Bluetooth-uppspelning med dedikerad ingångskanal",
            },
{
                list_data:"4x FX Assist engines",
 },
{
                list_data:"3x anpassade mjukvaruknappar",
            },
{
                list_data:"3x Smart Rotary",
            },
{
                list_data:"Dubbla footswitch-anslutningar",
            },
{
                list_data:"7” Kapacitiv pekskärm med tillhörande vridreglage",
            },
{
                list_data:"Inbyggd dual band 2,4G/5G AC Wi-Fi med automatiskt kanalval",
            },


        ],
        
        featured: "true",
        thumb: "./images/ljud/CQ-18T-Top.png",
        //gallery images
        gallery_img:[
            {
                img:"./images/ljud/CQ-18T-Top.png",
            },
                      
           
        ] ,

        // technical
        dimension:'346 x 242 x 88 mm',
        vikt_1:'3 kg',
        // all cases
        all_cases:[ 
          
         ],
         
        // icons
        icons:[
            {
                icon:"./images/icons/xlr3polv4.png",
                hovertext:'DMX 3-pol',
            }
        ] ,
        // download
        downloadable_link:[
            {
                d_img:"./images/download.png",
                d_heading:"CQ-series User guide",
                d_link:"./downloads/CQ_User_Guide_V1_2_0.pdf"
            },
           
        ],
    },
    {
        id: 11111,
        artnr: "010-111",
        category: "Mixerbord",
        product_name: "LS9 32 ch",
        producer: "Yamaha",
        thumb: "./images/ljud/ls932.png",
        level: 4,

        description:
          "LS9-32 är en kompakt, digital mixerkonsol med 32 mic/linje-ingångar (64 kanaler totalt i två lager). Trots sin lätta och portabla konstruktion erbjuder den samma funktionalitet, ljudkvalitet och användarvänlighet som Yamahas större digitalmixrar (t.ex. PM1D). Passar utmärkt för live-ljud i mindre till medelstora sammanhang samt fasta installationer. Innehåller inbyggd USB-inspelning/uppspelning, omfattande gate-, kompressor- och EQ-processing samt Yamahas välkända \"Selected Channel\"-gränssnitt för snabb åtkomst till kanalfunktioner.",

        all_lists:[
            {
                list_data:"Kanaler: 32 mono mic/linje + 4 stereo, upp till 64 kanaler i två lager",
            },
            {
                list_data:"Fader: 33x 100 mm motoriserade",
            },
            {
                list_data:"Bussar: 16 mixbussar, 8 matrisbussar, stereo/mono med LCR",
            },
            {
                list_data:"Mic-förförstärkare: 32x XLR med fantommatning",
            },
            {
                list_data:"Digitala in/ut: 1x MIDI, 1x Coax, 1x BNC (klocka)",
            },
            {
                list_data:"Huvudutgångar: 16x XLR (Omni)",
            },
            {
                list_data:"Data I/O: Ethernet, 1x USB Type-A",
            },
            {
                list_data:"Expansionsplatser: 2x mini-YGDAI kortplatser",
            },
            {
                list_data:"Samplingsfrekvens: 44,1 / 48 kHz (internt)",
            },
            {
                list_data:"Signalfördröjning: Mindre än 2,5 ms",
            },
            {
                list_data:"Hörlurar: 1x 6,3 mm",
            },
            {
                list_data:"Effektförbrukning: 170 W",
            },
        ],

        featured: "true",
        //gallery images
        gallery_img:[
            {
                img:"./images/ljud/ls932.png",
            },
        ] ,

        // technical
        dimension:'884 x 220 x 500 mm',
        vikt_1:'19,4 kg',
        // all cases
        all_cases:[ 

         ],

        // icons
        icons:[
            {
                icon:"./images/icons/apparat.png",
                hovertext:'Apparatkabel',
            },
            {
                icon:"./images/icons/xlr3polv4.png",
                hovertext:'XLR 3-pol',
            }
        ] ,
        // download
        downloadable_link:[
            {
                d_img:"./images/download.png",
                d_heading:"LS9-32 Manual",
                d_link:"./downloads/LS9-32 Manual.pdf"
            },
            {
                d_img:"./images/download.png",
                d_heading:"LS9-32 Datasheet",
                d_link:"./downloads/LS9-32 Datasheet.pdf"
            },
        ],
    },
    {
        id: 11196,
        artnr: "010-195",
        category: "Mixerbord",
        product_name: "SQ6",
        producer: "Allen & Heath",
        thumb: "./images/ljud/sq6.png",
        level: 4,

        description:
          "SQ-6 är en kompakt digitalmixer med 48 kanaler och 36 bussar, byggd kring Allen & Heaths 96kHz XCVI FPGA-motor med extremt låg latens (under 0,7 ms). Passar utmärkt för liveljud, konferens/AV, studio och kyrkor/föreningslokaler. Har 24+1 motoriserade fader i 6 lager, 24 mikrofonförförstärkare av professionell kvalitet, 12 stereomixar (perfekt för in-ear-monitorering) samt 8 stereo FX-motorer. Kan expanderas till upp till 48 mikrofoningångar via Allen & Heaths Everything I/O-familj, och är kompatibel med ME Personal Mixing System och valfria Dante/Waves-kort.",

        all_lists:[
            {
                list_data:"Kanaler: 48 in / 36 bussar",
            },
            {
                list_data:"Fader: 24+1 motoriserade, 6 lager (96 kanalstråk)",
            },
            {
                list_data:"Mic-förförstärkare: 24x XLR, fullt återkallningsbara",
            },
            {
                list_data:"Mixar: 12 stereomixar + LR, 3 stereomatriser",
            },
            {
                list_data:"Effekter: 8 interna stereo FX-motorer med returer",
            },
            {
                list_data:"Pekskärm: 7\" kapacitiv, 800x480, 24-bit RGB",
            },
            {
                list_data:"SoftKeys: 16 st, SoftRotary: 4 st",
            },
            {
                list_data:"Nätverk: SLink EtherCON (64x64 ch), I/O-port för Dante/Waves-kort",
            },
            {
                list_data:"USB: 32x32 USB-ljudgränssnitt + SQ-Drive-inspelning",
            },
            {
                list_data:"Latens: <0,7 ms (96 kHz XCVI FPGA-motor)",
            },
            {
                list_data:"Footswitch: Enkel eller dubbel anslutning",
            },
        ],

        featured: "true",
        //gallery images
        gallery_img:[
            {
                img:"./images/ljud/sq6.png",
            },
        ] ,

        // technical
        dimension:'638 x 198 x 515 mm',
        vikt_1:'14,5 kg',
        // all cases
        all_cases:[ 

         ],

        // icons
        icons:[
            {
                icon:"./images/icons/apparat.png",
                hovertext:'Apparatkabel',
            },
            {
                icon:"./images/icons/xlr3polv4.png",
                hovertext:'XLR 3-pol',
            }
        ] ,
        // download
        downloadable_link:[
            {
                d_img:"./images/download.png",
                d_heading:"SQ-6 Technical Datasheet",
                d_link:"./downloads/SQ-6 Technical Datasheet.pdf"
            },
            {
                d_img:"./images/download.png",
                d_heading:"SQ-6 User guide",
                d_link:"./downloads/SQ-6 User guide.pdf"
            },
        ],
    },
    {
        id: 11195,
        artnr: "011195",
        category: "Mixerbord",
        product_name: "VLZ 1402",
        thumb: "./images/ljud/vlz1402.png",
        producer: "Mackie",
        level: 4,

        description:
          "1402VLZ4 är en analog kompaktmixer med 14 kanaler, väl anpassad för liveljud, studio och enklare inspelning. Byggd kring Mackies XDR-mikrofonförförstärkare (Onyx) med hög headroom och låg brusnivå. Har 6 mic/linje-kanaler, 4 stereokanaler samt 2 stereo aux-returer. Varje mono-kanal har 3-bands EQ, ett HPF-filter (75 Hz) och en insert-punkt. Robust konstruktion i solid stålchassi gör den lämplig för både studiobruk och tuffare scenmiljöer.",

        all_lists:[
            {
                list_data:"Kanaler: 14 (6 mic/linje + 4 stereo)",
            },
            {
                list_data:"Mic-förförstärkare: 6x Onyx (XDR2)",
            },
            {
                list_data:"Aux-sändningar: 2 per kanal",
            },
            {
                list_data:"EQ: 3-band aktiv på mono-kanaler",
            },
            {
                list_data:"Högpassfilter: 75 Hz, 18 dB/oktav (switchbar per kanal)",
            },
            {
                list_data:"Fantommatning: Global 48V",
            },
            {
                list_data:"Inserts: 6 st balanserade kanalinserts",
            },
            {
                list_data:"Control Room-sektion: Ja, med källmatris",
            },
            {
                list_data:"Frekvensomfång: 20 Hz - 60 kHz (+0/-1 dB)",
            },
            {
                list_data:"Huvudutgång: XLR, +28 dBu max",
            },
        ],

        //gallery images
        gallery_img:[
            {
                img:"./images/ljud/vlz1402.png",
            },
        ] ,

        // technical
        dimension:'356 x 81 x 318 mm',
        vikt_1:'5,4 kg',
        // all cases
        all_cases:[ 

         ],

        // icons
        icons:[
            {
                icon:"./images/icons/apparat.png",
                hovertext:'Apparatkabel',
            },
            {
                icon:"./images/icons/xlr3polv4.png",
                hovertext:'XLR 3-pol',
            }
        ] ,
        // download
        downloadable_link:[
            {
                d_img:"./images/download.png",
                d_heading:"1402VLZ4 Manual",
                d_link:"./downloads/1402VLZ4 Manual.pdf"
            },
            {
                d_img:"./images/download.png",
                d_heading:"1402VLZ4 Specification Sheet",
                d_link:"./downloads/1402VLZ4 Specification Sheet.pdf"
            },
        ],
    },
    {
        id: 11491,
        artnr: "011-491",
        category: "Mixerbord",
        product_name: "MMX-602",
        thumb: "./images/no_img.png",
        producer: "StageLine",
        level: 4,

        description:
          "MMX-602 är en enkel 6-kanalig mikrofon-/linjemixer avsedd för scenbruk, bakgrundsmusik och mindre PA-installationer. Varje kanal har en balanserad mono mikrofoningång (XLR) samt en stereo linjeingång (RCA) som kan väljas individuellt, med balanskontroll för stereosignalen. Kanal 1 (eller 1+2) har en aktiverbar automatisk talover-funktion (-12 dB) som sänker övriga kanaler när tal detekteras. 12V fantommatning kan aktiveras vid behov. Utrustad med 3-bands EQ, master- och inspelningsutgång, switchbar stereo/mono-drift samt hörlursutgång. Rackmonterbar i 19\", 1U.",

        all_lists:[
            {
                list_data:"Kanaler: 6 (mic/linje)",
            },
            {
                list_data:"Mikrofoningångar: 6x XLR, balanserad",
            },
            {
                list_data:"Linjeingångar: 6x stereo RCA",
            },
            {
                list_data:"Talover: -12 dB, aktiverbar för kanal 1 eller 1+2",
            },
            {
                list_data:"EQ: 3-band (bas ±12dB/50Hz, mellan ±12dB/1kHz, diskant ±12dB/10kHz)",
            },
            {
                list_data:"Fantommatning: 12V, aktiverbar",
            },
            {
                list_data:"Huvudutgång: 1x XLR L/R balanserad, 1x RCA L/R",
            },
            {
                list_data:"Inspelningsutgång: 1x RCA L/R",
            },
            {
                list_data:"Hörlursutgång: 1x 6,3 mm jack",
            },
            {
                list_data:"Frekvensomfång: 20 - 20 000 Hz",
            },
            {
                list_data:"Rackmått: 19\", 1U",
            },
        ],

        //gallery images
        gallery_img:[
            {
                img:"./images/no_img.png",
            },
        ] ,

        // technical
        dimension:'482 x 47 x 208 mm',
        vikt_1:'2,8 kg',
        // all cases
        all_cases:[ 

         ],

        // icons
        icons:[
            {
                icon:"./images/icons/apparat.png",
                hovertext:'Apparatkabel',
            },
            {
                icon:"./images/icons/xlr3polv4.png",
                hovertext:'XLR 3-pol',
            }
        ] ,
        // download
        downloadable_link:[
            {
                d_img:"./images/download.png",
                d_heading:"MMX-602 Manual",
                d_link:"./downloads/MMX-602 Manual.pdf"
            },
        ],
    },
    {
        id: 10197,
        category: "Mixerbord",
        product_name: "DT168",
        level: 4,
        producer: "Allen & Heath",
        artnr: "010-199",
        description:
          "DT168 har 16 mikrofonförförstärkare och 8 linjeutgångar i en smidig stagebox. Den kan användas på scen eller som en drop-in-expander i alla SQ-, Avantis-, AHM-64- eller dLive Dante-nätverk. DT168 erbjuder 96kHz-omvandlare för klassens bästa ljudkvalitet över Dante nätverk, plus primära och sekundära portar för daisy-chain eller redundans genom EtherCon-kontakter med lås. Upp till 16 enheter kan läggas till ett AHM, SQ, Avantis eller dLive-system när de är utrustade med ett SQ Dante- eller dLive 96kHz Dante-kort.",
          
          all_lists:[
            {
                list_data: "Dante ljudexpander, 96kHz / 48kHz",
            },
            {
                list_data:"16 mikrofonförstärkare med XLR och fantommatnig med statusdioder",
            },
            {
                list_data:"8 XLR Line Outs",
            },
            {
                list_data:"Primär och sekundär Dante-portar med låsande EtherCon kontakter",
            },
{
                list_data:"Redundant eller Switchat läge",
            },
{
                list_data:"Direkt preampkontroll från dLive, Avantis, AHM och SQ",
            },
{
                list_data:"19-tums rackmonteringssats",
            },
{
                list_data:"AES67 kompatibel",
            },

        ],
        
        featured: "true",
        thumb: "./images/ljud/dt168.png",
        //gallery images
        gallery_img:[
            {
                img:"./images/ljud/dt168.png",
            },
             {
                img:"./images/ljud/DT168_3.webp",
            },
                        
                      
           
        ] ,

        // technical
        dimension:'390 x 189 x 182 mm',
        vikt_1:'5 kg',
        // all cases
        all_cases:[ 
          
         ],
         
        // icons
        icons:[
            {
                icon:"./images/icons/xlr3polv4.png",
                hovertext:'DMX 3-pol',
            }
        ] ,
        // download
        downloadable_link:[
            {
                d_img:"./images/download.png",
                d_heading:"DT168 Manual",
                d_link:"./downloads/dt168-manual.pdf"
            },
            {
                d_img:"./images/download.png",
                d_heading:"DT168 Datasheet",
                d_link:"./downloads/dt168-datasheet.pdf"
            },
           
        ],
    },

    // Signalhantering

    {
        id: 13302,
        artnr: "013-302",
        category: "Signalhantering",
        product_name: "iEQ31",
        thumb: "./images/no_img.png",
        producer: "DBX",
        level: 4
    },
    {
        id: 13901,
        artnr: "013-901",
        category: "Signalhantering",
        product_name: "SP8 Splitter",
        thumb: "./images/no_img.png",
        producer: "Millenium",
        level: 4
    },
    {
        id: 13902,
        artnr: "013-902",
        category: "Signalhantering",
        product_name: "Splitt It Mk2",
        thumb: "./images/no_img.png",
        producer: "T.rack",
        level: 4
    },
    {
        id: 13903,
        artnr: "013-903",
        category: "Signalhantering",
        product_name: "Eight 8",
        thumb: "./images/no_img.png",
        producer: "T.rack",
        level: 4
    },

    // DJ Utrustning
    {
        id: 14002,
        artnr: "010-198",
        category: "DJ Utrustning",
        product_name: "XDJ-RX3",
        thumb: "./images/ljud/rx3.png",
        producer: "Pioneer",
        level: 4
    },
    {
        id: 14001,
        artnr: "014-001",
        category: "DJ Utrustning",
        product_name: "Mixdeck",
        thumb: "./images/ljud/mixdeck.png",
        producer: "Numark",
        level: 4
    },
   

    // Mikrofoner
    {
        id: 15-121,
        category: "Mikrofoner",
        product_name: "SM58",
        level: 4,
        producer: "Shure",
        artnr: "015-121",
        description:
          "Världens mest sålda sångmikrofon. Dynamisk mikrofon med kardioid (njur-) karakteristik, speciellt framtagen för scen- och studioanvändning av sång och tal. Robust konstruktion som tål hård turnéanvändning. Frekvensomfång: 50–15 000 Hz.",
        featured: "true",
        thumb: "./images/ljud/sm58.png",
    },
    {
        id: 15-122,
        category: "Mikrofoner",
        producer: "Shure",
        product_name: "Beta 58A",
        artnr: "015-122",
        thumb: "./images/ljud/beta58.png",
        description:
          "Beta 58A har designmässigt inspirerats av SM58 men är på många sätt förbättrad. Beta 58A har snabbt blivit accepterad som den nya proffs standarden av dynamiska sångmikrofoner. Beta 58A har en superkardioid karakteristik som är konstant vid så gott som alla frekvenser, vilket minimerar rundgångsproblemet. Den har en mycket kraftig utsignal genom användande av neodymiummagnet och har en förbättrad frekvensresponse, speciellt i diskantområdet. Mycket användbar vid höga ljudnivåer. Beta 58A har extremt lågt handljud. Dynamisk superkardioid. Frekvensomfång 50-16.000Hz.",
        level: 4
    },
    {
        id: 15-131,
        category: "Mikrofoner",
        producer: "Electro Voice",
        product_name: "Co9",
        artnr: "015-131",
        thumb: "./images/ljud/Co9.png",
        description:
          "En favorit bland vokalister inom alla stilar. Den har en viss dämpning i basregistret och ett dominerande mellanregister. Frekvensomfång: 50 - 18.000 Hz",
        level: 4
    },
    {
        id: 15-132,
        category: "Mikrofoner",
        producer: "Electro Voice",
        product_name: "PL44",
        artnr: "015-132",
        thumb: "./images/ljud/pl44.png",
        description:
          "Dynamisk mikrofon med superkardioid-karaktäristik. Färgad med en extra mellanregister-/diskanthöjning för att passa direkt i alla live-sammanhang. Frekvensomfång: 80-18.000 Hz",
        level: 4
    },
    {
        id: 15-223,
        category: "Mikrofoner",
        producer: "Shure",
        product_name: "SM57",
        artnr: "015-223",
        thumb: "./images/ljud/sm57.png",
        description:
          "Klassisk standardmikrofon för trummor, slagverk och uppmickning av instrumentförstärkare. SM57 har en noggrant utformad frekvensgång som ger en ren, väl avgränsad instrumentåtergivning och fyllig, varm röståtergivning från podier och scen. Därför har den blivit en flitigt använd arbetshäst bland världens studios och scener. Dynamisk kardioid. Frekvensomfång 40-15.000 Hz.",
        level: 4
    },
    {
        id: 15-222,
        category: "Mikrofoner",
        producer: "Shure",
        product_name: "Beta 57A",
        artnr: "015-222",
        thumb: "./images/ljud/beta57.png",
        description:
          "Trots att den inte varit med så länge har Beta 57 blivit en legend inom liveljud. Denna mikrofon är konstruerad dels för sång, dels för uppmikning av både elektriska och akustiska instrument, speciellt trummor, slagverk, blås och instrumentförstärkare - både i studio och på scen. Den robusta konstruktionen gör den extremt turnévänlig och tål mycket stryk. Utgångspunkten för Beta 57A är SM57, men med neodymiummagnet som ger bättre följsamhet och maximalt signal/brusförhållande. Dessutom har Beta 57A förbättrad frekvensrespons i både bas- och diskantområdet vilket ger ett mer öppet och naturligt ljud. Superkardioid, dynamisk mikrofon. Frekvensomfång: 50-16000Hz.",
        level: 4
    },
    {
        id: 15-241,
        category: "Mikrofoner",
        producer: "AKG",
        product_name: "C391",
        artnr: "015-241",
        thumb: "./images/ljud/c391.png",
        description:
          "Cardioid kondensatormikrofon. Komplett mik, med mik-kapsel (AKG CK91) och förstärkare (AKG SE 300 B), Mikpreamp för kapslar i Blue Line-serien; CK 91, CK 92, CK 93, CK 94 samt CK 98. Den robusta Modulock bayonet-kopplingen möjliggör snabbt och enkelt byte av kapseln. SE 300 B har även en bass-roll off switch med tre olika lägen; flat/plan, 75Hz och 10 dB dämpning. AKG C91: Njure. Kännetecknas av ett slätt och välbalanserat frekvensomfång. Perfekt för liveframträdanden och studio broadcasts där det är viktigt att ljud off-axis dämpas.",
        level: 4
    },
    {
        id: 15-251,
        category: "Mikrofoner",
        producer: "Line Audio",
        product_name: "CM3",
        artnr: "015-251",
        thumb: "./images/ljud/cm3.png",
        description:
          "CM3 är en liten och enormt smidig fantommatad kondensatormikrofon som kan användas till det mesta, både i studion och på scenen. Körer, förstärkare, trummor, akustisk gitarr. Frekvensomfång: 20-20000Hz",
        level: 4
    },
    {
        id: 15-261,
        category: "Mikrofoner",
        producer: "Sennheiser",
        product_name: "MD918U",
        artnr: "015-261",
        thumb: "./images/ljud/MD918U.png",
        description:
          "Dynamisk mikrofon med njur- (kardioid) karakteristik och på/av-knapp. Robust metallhölje avsett för professionellt scenbruk, tal och sång. Frekvensomfång: 50–15 000 Hz. Känslighet: 1,3 mV/Pa. Impedans: 200 Ohm. Ansluts via 3-polig XLR-kontakt, levereras med mikrofonhållare.",
        level: 4
    },
    {
        id: 15-271,
        category: "Mikrofoner",
        producer: "Röde",
        product_name: "M3",
        artnr: "015-271",
        thumb: "./images/ljud/m3.png",
        description:
          "M3 är en extremt mångsidig mikrofon för användning i studion, i hemmet, vid fältinspelning, eller varhelst en lågbrusig kondensatormik med njurekaraktäristik och bred frekvensupptagning behövs. M3 har LED-indikator för batterinivå, och High Pass Filter. Levereras med vindskydd och mikrofonhållare och drivs med ett 9V batteri eller via 48V fantommatning.",
        level: 4
    },
    {
        id: 15-311,
        category: "Mikrofoner",
        producer: "Sennheiser",
        product_name: "e604",
        artnr: "015-311",
        thumb: "./images/ljud/e604.png",
        description:
          "Kardioidmikrofon med sargfäste, speciellt anpassad för uppmickning av trummor och blåsinstrument.",
        level: 4
    },
    {
        id: 15-312,
        category: "Mikrofoner",
        producer: "Sennheiser",
        product_name: "md421",
        artnr: "015-312",
        thumb: "./images/ljud/md421.png",
        description:
          "Den allmänt förekommande, ikoniska – Sennheiser MD 421 kan hittas på varje scen och studio världen över. Med sin höga SPL hantering, goda bortstötning och praktiska filter alternativ, har MD 421 länge varit en standard när det kommer till dynamiska stormembrans mikrofoner, och huvudsaklig vid inspelning av gitarr förstärkare, pukor och sång. Fungerar helt enkelt till nästan till allt!",
        level: 4
    },
    {
        id: 15-313,
        category: "Mikrofoner",
        producer: "Sennheiser",
        product_name: "e906",
        artnr: "015-313",
        thumb: "./images/ljud/e906.png",
        description:
          "Superkardioid som är framtagen för gitarrförstärkare men som även är utmärkt för perkussion och blås.",
        level: 4
    },
    {
        id: 15-421,
        category: "Mikrofoner",
        producer: "Shure",
        product_name: "Beta 52A",
        artnr: "015-421",
        thumb: "./images/ljud/beta52.png",
        description:
        "Dynamisk bastrummemik med suverän attack och ”punch”.Beta 52A är en mikrofon med hög output och ett frekvenssvar som är anpassat för bastrumma och andra lågfrekvensinstrument. Mikrofonen ger en superb attack och ”punch” med studiokvalitet även under extremt höga ljudtrycksnivåer. BETA52A har en modifierad supercardioid för att säkerställa maximal gain innan feedback och för att eliminera oönskade bakgrundsljud. Stativadapter och XLR-kontakter är byggda för att förenkla installation, speciellt när mikrofonen är placerad inuti en baskagge. Tripod adaptern håller mikrofonen fixerad i önskad position, även under kraftiga vibrationer. En robust stålgrill skyddar mikrofonen även i krävande turnésammanhang",
        level: 4
    },
    {
        id: 15-501,
        category: "Mikrofoner",
        producer: "DPA",
        product_name: "4061 Svarta",
        artnr: "015-501",
        thumb: "./images/ljud/dpa4061.png",
        description:
          "Miniatyr fantommatad kondensatormikrofon med omnidirektionell (klotformad) karakteristik. Extremt liten och discret, avsedd för dold mikrofonering på teater, scen, broadcast/TV och vid närmikrofonering av instrument (t.ex. stråk, blås, kontrabas). Tål mycket höga ljudtryck. Frekvensomfång: 20–20 000 Hz. Känslighet: 6 mV/Pa. Brusnivå: 26 dB(A). Max SPL: 144 dB. Drivs via 48V fantommatning eller adapter för trådlösa system (5–50V).",
        level: 4
    },
    {
        id: 15-5011,
        category: "Mikrofoner",
        producer: "DPA",
        product_name: "4061 Beiga",
        artnr: "015-5011",
        thumb: "./images/ljud/dpa4061.png",
        description:
          "Miniatyr fantommatad kondensatormikrofon med omnidirektionell (klotformad) karakteristik, hudfärgad (beige) för discret placering i hud/hår vid teater, scen, broadcast/TV och närmikrofonering av instrument. Tål mycket höga ljudtryck. Frekvensomfång: 20–20 000 Hz. Känslighet: 6 mV/Pa. Brusnivå: 26 dB(A). Max SPL: 144 dB. Drivs via 48V fantommatning eller adapter för trådlösa system (5–50V).",
        level: 4
    },
    {
        id: 15505,
        category: "Mikrofoner",
        producer: "Sennheiser",
        product_name: "MKE2",
        artnr: "015-505",
        thumb: "./images/ljud/mke2.png",
        description:
          "Subminiatyr klädmikrofon (pettelmikrofon) med kondensatorelement och omnidirektionell karakteristik. Fukt- och svettresistent tack vare den dubbla membrankonstruktionen ("+"\"Umbrella Diaphragm\""+"). Används inom broadcast, teater, film, presentation och konferens där en discret, gömd mikrofon krävs. Levereras med utbytbara frekvenskorrigeringshattar för att justera diskantåtergivningen. Frekvensomfång: 20–20 000 Hz. Max SPL: 142 dB. Impedans: 1000 Ω. Kräver 12–48V fantommatning.",
        level: 4
    },
    {
        id: 15-511,
        category: "Mikrofoner",
        producer: "DPA",
        product_name: "4066",
        artnr: "015-511",
        thumb: "./images/ljud/dpa4066.png",
        description:
          "Headsetmikrofon (huvudmonterad klädmikrofon) med kondensatorelement och omnidirektionell karakteristik. Kan monteras på både vänster och höger sida av huvudet och tål fukt tack vare vattenavvisande konstruktion. Används flitigt inom teater, broadcast, konferens och liveframträdanden. Frekvensomfång: 20–20 000 Hz. Känslighet: 6 mV/Pa. Max SPL: 144 dB. Utgångsimpedans: 30–40 Ω. Drivs via 48V fantommatning eller adapter för trådlöst system (5–50V).",
        level: 4
    },
    {
        id: 15-521,
        category: "Mikrofoner",
        producer: "Audac",
        product_name: "CMX726S",
        artnr: "015-521",
        thumb: "./images/ljud/CMX726.png",
        description:
          "Headsetmikrofon med back-electret kondensatorelement och omnidirektionell karakteristik. Lätt och ergonomisk konstruktion avsedd för tal- och sångapplikationer inom konferens, teater, undervisning och scenframträdande. Levereras med fyra olika kontakttyper för anpassning till de vanligaste trådlösa systemen samt vindskydd och klämma. Frekvensomfång: 20–20 000 Hz. Impedans: 2000 Ω. Känslighet: -42 dB. Max SPL: 135 dB.",
        level: 4
    },
    {
        id: 15-531,
        category: "Mikrofoner",
        producer: "Sennheiser",
        product_name: "Intricot HT 747",
        artnr: "015-531",
        thumb: "./images/ljud/ht747.png",
        description:
          "HT 747 är en smidig headsetmikrofon, idealisk för aerobics, idrott eller gymverksamhet. Upptagningen är supercardioid vilket gör den väldigt okänslig för rundgång/ återkoppling. Bygeln är flexibel och i ett svettåligt material. Passar till Sennheiser trådlösa system med minitele 3.5mm ingång.", 
        level: 4
    },
    {
        id: 15-601,
        category: "Mikrofoner",
        producer: "Superlux",
        product_name: "PRA-383D",
        artnr: "015-601",
        thumb: "./images/ljud/pra383.png",
        description:
          "Klämmikrofon (clip-on) med kondensatorelement och super-/kardioid karakteristik, särskilt framtagen för blåsinstrument som trumpet, saxofon och klarinett, men även användbar på stråkinstrument. Levereras med förstärkarmodul (PS418D) som kan drivas via fantommatning eller batteri. Frekvensomfång: 40–18 000 Hz. Känslighet: 8,0 mV/Pa. Impedans: 200 Ω. Max SPL: ca 132–139 dB.",
        level: 4
    },
    {
        id: 15-611,
        category: "Mikrofoner",
        producer: "DPA",
        product_name: "4099",
        artnr: "015-611",
        thumb: "./images/ljud/DPA4099.png",
        description:
          "Instrumentmikrofon med kondensatorelement och superkardioid karakteristik, avsedd för närmikrofonering av akustiska instrument såsom gitarr, fiol, cello, blås, stråk, piano och slagverk. Monteras direkt på instrumentet med hjälp av utbytbara clips anpassade för olika instrumenttyper, vilket ger hög isolering mot omgivande ljud och gott gain-before-feedback. Finns i flera SPL-varianter (Loud/Extreme). Frekvensomfång: 20–20 000 Hz (effektivt frekvensomfång vid 20 cm avstånd: ca 80 Hz–15–17 kHz). Max SPL: upp till 142–160 dB beroende på variant.",
        level: 4
    },
    {
        id: 15-821,
        category: "Mikrofoner",
        producer: "Shure",
        product_name: "Super 55SH-BCR",
        artnr: "015-821",
        thumb: "./images/ljud/sh55.png",
        description:
          "Dynamisk sångmikrofon med superkardioid karakteristik och klassisk retrodesign (svart hus med rött skyddsnät, limited edition-variant av Super 55). Chockmonterad kapsel minimerar handhavande- och stativljud. Passar scen, studio, podcast och content creation. Frekvensomfång: 60–17 000 Hz.",
        level: 4
    },
    {
        id: 15-901,
        category: "Mikrofoner",
        producer: "T.bone",
        product_name: "MM-1",
        artnr: "015-901",
        thumb: "./images/ljud/mm-1.png",
        description:
          "Mätmikrofon (referensmikrofon) med kondensatorelement och äkta omnidirektionell (tryckmottagande) karakteristik. Används för akustiska mätningar, rumsanalys och kalibrering av högtalarsystem, men fungerar tack vare sin naturliga och detaljerade återgivning även utmärkt som inspelningsmikrofon, exempelvis som overheadmikrofon på trummor. Frekvensomfång: 20–20 000 Hz. Utgångsimpedans: 240 Ω. Max SPL: 132 dB. Fantommatning: +9V till +52V.",
        level: 4
    },
    {
        id: 15902,
        category: "Mikrofoner",
        producer: "iSEMcon",
        product_name: "EMX-7150",
        artnr: "015-902",
        thumb: "./images/ljud/isemcon.png",
        description:
          "Precisionsmätmikrofon (referensmikrofon) med 1/4\" kondensatorelement och omnidirektionell (fritt-fält) karakteristik. Extremt flat frekvensgång i \"klass 1\"-nivå gör den populär för professionella ljudmätningar, SPL-analys och rumsakustikmätning, bland annat tillsammans med mätprogram som Smaart. Vattentät konstruktion i rostfritt stål med Neutrik-kontakter, lämplig även för utomhusbruk. Frekvensomfång: 10–20 000 Hz. Max SPL: 145 dB. Fantommatning: 12–52V.",
        level: 4
    },

   // Trådlösa system
    {
    id: 16-301,
    artnr: "016-301",
    category: "Trådlösa system",
    product_name: "2 kanaler EW300 G3 A-band",
    producer: "Sennheiser",
    thumb: "./images/no_img.png",
    level: 4
    },
    {
    id: 16-501,
    artnr: "016-501",
    category: "Trådlösa system",
    product_name: "4 kanaler EW500 G3 A-band",
    producer: "Sennheiser",
    thumb: "./images/no_img.png",
    level: 4
    },
    {
    id: 16-502,
    artnr: "016-502",
    category: "Trådlösa system",
    product_name: "4 kanaler EW500 G3 G-band",
    producer: "Sennheiser",
    thumb: "./images/no_img.png",
    level: 4
    },  
    {
    id: 16-101,
    artnr: "016-101",
    category: "Trådlösa system",
    product_name: "Antenndistro rack",
    producer: "Sennheiser",
    thumb: "./images/no_img.png",
    level: 4
    },

   // Lineboxar

    {
        id: 17101,
        artnr: "017-101",
        category: "Lineboxar",
        product_name: "IMP2",
        producer: "Whirlwind",
        thumb: "./images/ljud/imp2.png",
        description:
          "IMP 2 Passiv DI-box. Instrument till mixer. Ingång: telehona. Utgångar: telehona till instrumentförstärkare och till mixer. Switch för Ground Lift.",
        level: 4
    },
    {
        id: 17102,
        artnr: "017-102",
        category: "Lineboxar",
        product_name: "AR133",
        producer: "BSS",
        description:
          "V",
        thumb: "./images/ljud/ar133.png",
         //gallery images
         gallery_img:[
            {
                img:"./images/ljud/ar133.png",
            },
            {
                img:"./images/ljud/ar133-1.png",
            },
        ] ,
        level: 4
    },
    {
        id: 1111,
        artnr: "017-111",
        category: "Lineboxar",
        product_name: "ProD2",
        producer: "Radial",
        description:
          "Stereo Direct Box.",
        thumb: "./images/ljud/pcdi.png",
        level: 4
    },
    {
        id: 17201,
        artnr: "017-201",
        category: "Lineboxar",
        product_name: "PcDI",
        producer: "Whirl Wind",
        description:
          "Stereo Direct Box för att koppla ihop dator/ljudkort med PA etc. Dämpar signalen ca -20dB eller -40dB med ”pad”. Sterero/mono-switch. Ingångar: 3,5mm stereotele, ¼”-tele och RCA. Utgångar: XLR.",
        thumb: "./images/ljud/pcdi.png",
        level: 4
    },
    {
        id: 17301,
        artnr: "017-301",
        category: "Lineboxar",
        product_name: "Bluetooth",
        producer: "Denon",
        level: 4,
        description:
          "Diskret och robust mottagare som tar emot signaler trådlöst via Bluetooth. Via dess balanserade XLR eller obalanserade 6,3 mm utgångar kan sedan signalen skickas vidare till mix eller förstärkarsystem. DN-200BR kommer ihåg 8st enheter i dess minne. Kopplas fler enheter upp, plockas automatisk den äldsta bort. XLR och ¼” utgångar Extern BNC-antenn Remote ”pair funktion” 20 Hz – 20 000Hz. Bluetooth version 4. Codec: SBC, MP3, AAC, aptX",
 
          // technical
        dimension:'149 x 117 x 45 mm',
        vikt_1:'0,6 kg',

        thumb: "./images/ljud/br200.png",
         //gallery images
         gallery_img:[
            {
                img:"./images/ljud/br200.png",
            },
            {
                img:"./images/ljud/br200_1.png",
            },
            {
                img:"./images/ljud/br200_2.png",
            },
                      
        ] ,
    },

   // Ljudstativ

    {
        id: 18-101,
        artnr: "018-101",
        category: "Ljudstativ",
        product_name: "DS2 S Minihögtalarstativ",
        producer: "DB Technologies",
        thumb: "./images/ljud/ds4.png",
        level: 4
    },
    {
        id: 18-102,
        artnr: "018-102",
        category: "Ljudstativ",
        product_name: "Högtalartapp",
        producer: "Doughty",
        thumb: "./images/ljud/doughtytapp.png",
        level: 4,
        all_lists:[
            {
                list_data:"Spigot: 28 mm",
            },
            {
                list_data:"Högtalartapp: 35 mm",
            },
            ],
    },
    {
        id: 18-302,
        artnr: "018-302",
        category: "Ljudstativ",
        product_name: "Älghorn",
        producer: "Doughty",
        thumb: "./images/ljud/alghorn.png",
        level: 4,
        all_lists:[
            {
                list_data:"Bredd: 310-490 mm",
            },
            {
                list_data:"Vikt: 1,5 kg",
            },
            ],
    },
    {
        id: 18-121,
        artnr: "018-121",
        category: "Ljudstativ",
        product_name: "Högtalarstativ",
        producer: "König & Meyer",
        thumb: "./images/ljud/21339.png",
        level: 4,
        all_lists:[
            {
                list_data:"Högtalarstativ med vev",
            },
            {
                list_data:"Höjd: 1385-2180 mm",
            },
            {
                list_data:"Max load: 50 kg",
            },
            {
                list_data:"Vikt: 9 kg",
            },
            ],
    },
    {
        id: 18-131,
        artnr: "018-231",
        category: "Ljudstativ",
        product_name: "Dansbandspinne",
        producer: "König & Meyer",
        thumb: "./images/ljud/dansbandspinne.png",
        level: 4,
        all_lists:[
            {
                list_data:"Dansbandspinne med vev",
            },
            {
                list_data:"Höjd: 940-1505 mm",
            },
            {
                list_data:"Max load: 35 kg",
            },
            {
                list_data:"Stativände topp: 35 mm högtalartapp",
            },
            {
                list_data:"Stativände botten: M20 gäng",
            },
            {
                list_data:"Vikt: 4 kg",
            },
            ],
    },
    {
        id: 18-201,
        artnr: "018-201",
        category: "Ljudstativ",
        product_name: "Mikrofonstativ",
        producer: "König & Meyer",
        thumb: "./images/ljud/210.png",
        level: 4,
        all_lists:[
            {
                list_data:"Höjd: 925-1630 mm",
            },
            {
                list_data:"Bom: 425-725 mm",
            },
            {
                list_data:"Vikt: 3 kg",
            },
            
        ],
    },
    {
        id: 18202,
        artnr: "018-202",
        category: "Ljudstativ",
        product_name: "Mikrofonstativ med rund fot",
        producer: "König & Meyer",
        thumb: "./images/ljud/260.png",
        level: 4,
        all_lists:[
            {
                list_data:"Höjd: 870-1565 mm",
            },
            {
                list_data:"Vikt: 5,8 kg",
            },
            
        ],
    },
    {
        id: 18221,
        artnr: "018-221",
        category: "Ljudstativ",
        product_name: "Kort mikrofonstativ",
        producer: "König & Meyer",
        thumb: "./images/ljud/259.png",
        level: 4,
        all_lists:[
            {
                list_data:"Bomlängd: 525 mm",
            },
            {
                list_data:"Höjd: 280 mm",
            },
            {
                list_data:"Vikt: 1,9 kg",
            },
           
        ],

    },
    {
        id: 18231,
        artnr: "018-231",
        category: "Ljudstativ",
        product_name: "23550 Mikrofon bar",
        producer: "König & Meyer",
        thumb: "./images/ljud/23550.png",
        level: 4,
        all_lists:[
            {
                list_data:"Längd: 200 mm",
            },
            {
                list_data:"Vikt: 0,13 kg",
            },
            {
                list_data:"Gäng: 3/8",
            },
           
        ],

    },

   // Ljudverktyg

    {
    id: 65603,
    category: "Ljudverktyg",
    producer: "Motu",
    product_name: "M4 USB-C Ljudkort",
    thumb: "./images/ljud/motum4.png",
    level: 4,
    // 
    artnr: "065-603",
    featured: "true",
   
    },
    {
        id: 19201,
        artnr: "019-201",
        category: "Ljudverktyg",
        product_name: "HD9 Hörlurar",
        producer: "Presonius",
        thumb: "./images/no_img.png",
        level: 4,
    },
    {
        id: 19202,
        artnr: "019-202",
        category: "Ljudverktyg",
        product_name: "PAA3 DB Mätare",
        producer: "Phonic",
        thumb: "./images/ljud/PAA3.png",
        level: 4,
    },
    {
        id: 19203,
        artnr: "019-202",
        category: "Ljudverktyg",
        product_name: "Lundahl Trafo",
        producer: "Lundahl",
        thumb: "./images/ljud/.png",
        level: 4,
    },
    {
        id: 19204,
        artnr: "019-202",
        category: "Ljudverktyg",
        product_name: "Qlab",
        producer: "Protonic",
        thumb: "./images/ljud/.png",
        level: 4,
    },

    // LJUS

    // Ljusbord
{
        id: 30101,
        level: 4,
        category: "Ljusbord",
        product_name: "Titan Mobile + Wing",
        producer: "Avolites",
        artnr: "030-101",
         
        description:
          "Avolites ljusbord",
        
         
        featured: "true",
        
     //gallery images
         thumb: "./images/ljus/avotitanmobile.png",
        
},
{
    id: 30102,
    artnr: "030-110",
    category: "Ljusbord",
    product_name: "Titan One",
    producer: "Avolites",
    thumb: "./images/ljus/titanone.png",
    level: 4,
},
{
        id: 30224,
        level: 4,
        category: "Ljusbord",
        product_name: "SimpleDesk 24",
        producer: "Fusion by GLP",
        artnr: "030-224",
         
        description:
          "SimpleDesk 24 är en 19\" 24 kanals DMX-styrenhet som också skulle kunna användas som en Faderwing. På baksidan av ljusbordet är det möjligt att ställa in startadresserna med hjälp av de integrerade DIP-switcharna. Ljusbordet har både 3 och 5-polig XLR för DMX in och ut",
        
         
        featured: "true",
        
     //gallery images
         thumb: "./images/ljus/simpledesk24.png",
        
         gallery_img:[
            {
                img:"./images/ljus/simpledesk24.png",
            },
            {
                img:"./images/ljus/simpledesk24_2.png",
            },
                     
        ] ,

         // technical
         dimension:'482 x 133 x 82 mm',
         vikt_1:'3 kg',

       
        // icons
        icons:[
            {
                icon:"./images/icons/xlr3polv4.png",
                hovertext:'DMX 3-pol',
            },
            {
                icon:"./images/icons/xlr5pol.png",
                hovertext:'DMX 5-pol',
            },
            
        ] ,

      // download
      downloadable_link:[
        {
            d_img:"./images/download.png",
            d_heading:"SimpleDesk 24 Manual",
            d_link:"./downloads/simpledesk24.pdf"
        },
     
    ],
},
{
    id: 30226,
    artnr: "030-202",
    category: "Ljusbord",
    product_name: "SDC12",
    producer: "Elation",
    level: 4,
     //gallery images
         thumb: "./images/ljus/SDC12.png",
        
         gallery_img:[
            {
                img:"./images/ljus/SDC12.png",
            },
            {
                img:"./images/ljus/SDC12_back.png",
            },
                     
        ] ,
},

    // Signalhantering
    {
        id: 31115,
        artnr: "031-115",
        category: "DMX distribution",
        product_name: "DMX Wireless transmitter",
        producer: "Beamz Pro",
        thumb: "./images/ljus/Beamz-wl.png",
        level: 4,
        description:  "En kompakt trådlös DMX-sändare/mottagare som kan styra upp till 7 universum. Universumen är markerade med en färgad LED i chassit. Du kan använda flera mottagare på en och samma sändare. Denna är anpassad för BBP54 Batteridrivna Uplights och andra BeamZ Pro armaturer. ",
    
all_lists:[
        {
            list_data:"3-pin XLR",
        },
        {
            list_data:"Eazylink W-DMX protokoll (15m inomhus, 25m utomhus)",
        },
        {
            list_data:"Frekvensområde 2.4-2.525GHz",
        },        
        
    ],
     // technical
    dimension:'105x150x55 mm',
    vikt_1:'0,25 kg',

       // icons
    icons:[
        {
            icon:"./images/icons/xlr3polv4.png",
            hovertext:'Batteri',
        },
  
    ] ,
    // download
    downloadable_link:[
        {
            d_img:"./images/download.png",
            d_heading:"BeamZ W-DMX Manual",
            d_link:"./downloads/W-DMX_manual.pdf"
        },   
    ],


    },
    {
        id: 31201,
        artnr: "031-201",
        category: "DMX distribution",
        product_name: "E-node 8 Pro",
        producer: "Elation",
        thumb: "./images/no_img.png",
        level: 4
    },    
    {
        id: 31301,
        artnr: "031-301",
        category: "DMX distribution",
        product_name: "DMX splitter 4 mk2",
        producer: "Stairville",
        thumb: "./images/no_img.png",
        level: 4,
    },
    {
        id: 31311,
        artnr: "031-311",
        category: "DMX distribution",
        product_name: "D-split",
        producer: "Enttec",
        thumb: "./images/no_img.png",
        level: 4,
    },

    // Ramper
    {
        id: 32901,
        artnr: "032-901",
        category: "Ramper",
        product_name: "Mega TRI 60",
        producer: "American DJ",
        thumb: "./images/ljus/megatri60.png",
        level: 4,   
      
      all_lists:[
        {
            list_data:"9x3W 3-i-1 TRI Color RBG LED",
        },
        {
            list_data:"Spridning: 25°",
        },
        {
            list_data:"3-pol XLR in och ut",
        },
        {
            list_data:"DMX, Master/Slave, Stand Alone och ljudstyrd via inbyggd mikrofon",
        },
        {
            list_data:"2, 3, 4, 6, 7, 12 eller 54 kanaler",
        },
        {
            list_data:"Strobe funktion",
        },
        {
            list_data:"Flicker-free användning inom film och TV",
        },
        {
            list_data:"Elektronisk dimming: 0 - 100%",
        },        
        {
            list_data:"Strömförbrukning max 40W",
        },
    ],
  
    //gallery images
    gallery_img:[
        {
            img:"./images/ljus/megatri60.png",
        },
          {
            img:"./images/ljus/megatri60_2.png",
        },
          {
            img:"./images/ljus/megatri60_3.png",
        },
        {
            img:"./images/ljus/megatri60back.png",
        },
                  
    ] ,

    // technical
    dimension:'60 x 7 x 10 mm',
    vikt_1:'3 kg',

        
 
    // icons
    icons:[
        {
            icon:"./images/icons/xlr3polv4.png",
            hovertext:'DMX 3-pol',
        },

    ] ,
    // download
    downloadable_link:[
        {
            d_img:"./images/download.png",
            d_heading:"American DJ Mega TRI 60 Manual",
            d_link:"./downloads/megatri60.pdf"
        },
        
    ],
    },
    {
        id: 32921,
        artnr: "032-921",
        category: "Ramper",
        product_name: "Show Bar Pro 16 RGBAW IP65",
        producer: "Stairville",
        thumb: "./images/no_img.png",
        level: 4,
    },

    // LED
    {
        id: 32-101,
        level: 4,
        category: "LED",
        product_name: "2 Bright Blind 3k IP",
        producer: "Ignition",
        artnr: "032-101",
        
        description:
        "En klassisk armatur för livekonserter m.m. Används ofta för att blända publiken eller låta glöda när man vill att publiken skall sjunga med ",  
        
        all_lists:[
            {
                list_data:"LED: 2 x 100 W Varmvit",
            },
            {
                list_data:"Spridning: 90°",
            },
            {
                list_data:"CRI: >90",
            },
            {
                list_data:"Färgtemperatur: 3000K",
            },
            {
                list_data:"DMX kanaler: 1/2/3/6",
            },
            {
                list_data:"IP: IP65",
            },
            {
                list_data:"Ström: True1 In / Ut",
            },
            {
                list_data:"DMX: XLR 3-pol In / Ut",
            },



        ],

        thumb: "./images/ljus/blinder.png",
        featured: "true",
         //gallery images

         gallery_img:[
            {
                img:"./images/ljus/blinder_back.png",
            },
            {
                img:"./images/ljus/blinder_case.png",
            },
            
           
        ] ,

         // technical
         dimension:'400 x 230 x 260 mm',
         vikt_1:'9 kg',

       // all cases
       all_cases:[ 
        {
            case_info:'För 2 st Blinders',
            vikt_2:"44 kg",
            storlek:"595 x 595 x 480 mm",
        },
    
     ],
      
        // icons
        icons:[
            {
                icon:"./images/icons/true1.png",
                hovertext:'True1',
            },
            {
                icon:"./images/icons/led.png",
                hovertext:'LED lampa',
            },
            
            {
                icon:"./images/icons/xlr3polv4.png",
                hovertext:'XLR 3-pol',
            },
            {
                icon:"./images/icons/triggerclamp.png",
                hovertext:'Trigger clamp',
            },
            {
                icon:"./images/icons/ip65.png",
                hovertext:'IP65',
            }
        ] ,

      // download
      downloadable_link:[
        {
            d_img:"./images/download.png",
            d_heading:"Ignition 2 Bright Blinder Manual",
            d_link:"./downloads/ignition_blinder.pdf"
        },
       
    ],
    },
    {
        id: 32520,
        level: 4,
        category: "LED",
        product_name: "Pro Slim Par 36 TLC",
        producer: "Futurelight",
        artnr: "032-520",
        
        description:
        "En klassisk LED lampa för att färga in. Varje diod är Röd, Grön och Blå. Kan används både som scenljus eller miljöljus", 
        all_lists:[
            {
                list_data:"Antal dioder: 18 st",
            },
            {
                list_data:"Diodtyp: 3 Watt TLC RGB diod",
            },
            {
                list_data:"Spridning: 18°",
                
            },
            {
                list_data:"DMX: 3-pol XLR In / Ut",    
            },
            {
                list_data:"DMX kanaler: 3/4/5/9", 
            },
            {
                list_data:"Musikstyrning: Har inbyggd mikrofon",
            },
            {
                list_data:"Max Effekt: 55 Watt",
            },
            {
                list_data:"Ström: PowerCon In / Ut",
            },
        ],
  
        
        featured: "true",
        
        //gallery images
         thumb: "./images/ljus/slimpar18.png",
         gallery_img:[
            {
                img:"./images/ljus/slimpar18.png",
            },
            {
                img:"./images/ljus/slimpar18_back.png",
            },
            
           
        ] ,

         // technical
         dimension:'263 x 100 x 300 mm',
         vikt_1:'4 kg',

       // all cases
       all_cases:[ 
        {
            case_info:'För 8 st Pro Slim Par',
            vikt_2:"64 kg",
            storlek:"900 x 600 x 600 mm",
        },
    
     ],
      
        // icons
        icons:[
            {
                icon:"./images/icons/powercon.png",
                hovertext:'PowerCon',
            },
            {
                icon:"./images/icons/led.png",
                hovertext:'LED lampa',
            },
            {
                icon:"./images/icons/rgb.png",
                hovertext:'Röd Grön Blå',
            },
            
            {
                icon:"./images/icons/xlr3polv4.png",
                hovertext:'XLR 3-pol',
            },
            
            {
                icon:"./images/icons/sound.png",
                hovertext:'Ljudstyrd',
            },
          
          
        ] ,

      // download
      downloadable_link:[
        {
            d_img:"./images/download.png",
            d_heading:"Futurelight Pro Slim Par 18 TLC manual",
            d_link:"./downloads/slimpar18.pdf"
        },
       
    ],
    },
    {
    id: 32521,
    level: 4,
    category: "LED",
    product_name: "Pro Slim Par 18 TLC RBG",
    producer: "Futurelight",
    artnr: "032-521",
    
    description:
    "En klassisk LED lampa för att färga in. Varje diod är Röd, Grön och Blå. Kan används både som scenljus eller miljöljus", 
    all_lists:[
        {
            list_data:"Antal dioder: 18 st",
        },
        {
            list_data:"Diodtyp: 3 Watt TLC RGB diod",
        },
        {
            list_data:"Spridning: 18°",
            
        },
        {
            list_data:"DMX: 3-pol XLR In / Ut",    
        },
        {
            list_data:"DMX kanaler: 3/4/5/9", 
        },
        {
            list_data:"Musikstyrning: Har inbyggd mikrofon",
        },
        {
            list_data:"Max Effekt: 55 Watt",
        },
        {
            list_data:"Ström: PowerCon In / Ut",
        },
    ],

    
    featured: "true",
    
    //gallery images
     thumb: "./images/ljus/slimpar18.png",
     gallery_img:[
        {
            img:"./images/ljus/slimpar18.png",
        },
        {
            img:"./images/ljus/slimpar18_back.png",
        },
        
       
    ] ,

     // technical
     dimension:'263 x 100 x 300 mm',
     vikt_1:'4 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'För 8 st Pro Slim Par',
        vikt_2:"64 kg",
        storlek:"900 x 600 x 600 mm",
    },

 ],
  
    // icons
    icons:[
        {
            icon:"./images/icons/powercon.png",
            hovertext:'PowerCon',
        },
        {
            icon:"./images/icons/led.png",
            hovertext:'LED lampa',
        },
        {
            icon:"./images/icons/rgb.png",
            hovertext:'Röd Grön Blå',
        },
        
        {
            icon:"./images/icons/xlr3polv4.png",
            hovertext:'XLR 3-pol',
        },
        
        {
            icon:"./images/icons/sound.png",
            hovertext:'Ljudstyrd',
        },
      
      
    ] ,

  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"Futurelight Pro Slim Par 18 TLC manual",
        d_link:"./downloads/slimpar18.pdf"
    },
   
],
    },
    {
    id: 32701,
    artnr: "032-701",
    category: "LED",
    product_name: "32  Hex Panel IP",
    producer: "American DJ",
    thumb: "./images/ljus/32hex.png",
    level: 4,

//gallery images
    
     gallery_img:[
        {
            img:"./images/ljus/32hex.png",
        },
        {
            img:"./images/ljus/32hexback.png",
        },
        {
            img:"./images/ljus/32hexfrost.png",
        },
        {
            img:"./images/ljus/32hexcase.png",
        },
        
       
    ] ,
     // icons
    icons:[
        {
            icon:"./images/icons/true1.png",
            hovertext:'True1',
        },
        {
            icon:"./images/icons/led.png",
            hovertext:'LED lampa',
        },
        {
            icon:"./images/icons/rgb.png",
            hovertext:'Röd Grön Blå',
        },
        
        {
            icon:"./images/icons/xlr5pol.png",
            hovertext:'XLR 5-pol',
        },
        
      
      
      
    ] ,

     // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"American DJ 32 Hex panel IP manual",
        d_link:"./downloads/ADJ_32hexpanel_manual.pdf"
    },
   
],

    },
  
   // Moving Heads
{
    id: 33401,
    category: "Moving Heads",
    product_name: "Hero Wash 300 FC",
    level: 4,
    producer: "Varytec",
    artnr: "033-401",
    description:
      "Shure mikrofon..Line array speaker zoom range from narrow 6° beam to wide 50° wash, Uniform illumination of the light cone. Sophisticated fan management with three selectable modes: Silent, Max and Auto. Adjustable pan and tilt range with selectable start and end points. 4 Selectable dimmer curves. Adjustable PWM",
    pdf: "./../assets/manuals/Varytec.pdf",
    featured: "true",
    thumb: "./images/ljus/Varytec300.png",
    //gallery images
    gallery_img:[
        {
            img:"./images/ljus/Varytec300.png",
        },        
    ] ,

    // technical
    dimension:'575 x 257 x 184 mm',
    vikt_1:'10 kg',

    // all cases
    all_cases:[ 
        {
        case_info:'För 4 st Elation ACL 360 Bar',
        vikt_2:"75 kg",
        storlek:"1100 x 640 x 470 mm",
        },
        {
        case_info:'För 8 st Elation ACL 360 Bar',
        vikt_2:"110 kg",
        storlek:"1200 x 600 x 600 cm",
        },
     ],
     
    // icons
    icons:[
        {
            icon:"./images/icons/triggerclamp.png",
            hovertext:'Trigger clamp',
        },
        {
            icon:"./images/icons/powercon.png",
            hovertext:'PowerCon',
        },
        {
            icon:"./images/icons/xlr3polv4.png",
            hovertext:'DMX 3-pol',
        },
        {
            icon:"./images/icons/xlr3polv4.png",
            hovertext:'DMX 3-pol',
        }
    ] ,
    // download
    downloadable_link:[
        {
            d_img:"./images/download.png",
            d_heading:"Varytec Hero Wash 300 FC Manual",
            d_link:"./downloads/Varytec Hero 300 FC manual.pdf"
        },
        
    ],
},
{
    id: 33501,
    category: "Moving Heads",
    product_name: "ACL 360 Bar",
    level: 4,
    producer: "Elation",
    artnr: "033-501",
    description:
      "Shure mikrofon..Line array speaker zoom range from narrow 6° beam to wide 50° wash, Uniform illumination of the light cone. Sophisticated fan management with three selectable modes: Silent, Max and Auto. Adjustable pan and tilt range with selectable start and end points. 4 Selectable dimmer curves. Adjustable PWM",
    pdf: "./../assets/manuals/Varytec.pdf",
    featured: "true",
    thumb: "./images/ljus/ACL360.png",
    //gallery images
    gallery_img:[
        {
            img:"./images/ljus/ACL360.png",
        },
        {
            img:"./images/ljus/ACL3601.png",
        },
        {
            img:"./images/ljus/ACL3602.png",
        },
        {
            img:"./images/ljus/ACL3603.png",
        },
        {
            img:"./images/ljus/ACL3604.png",
        },
        {
            img:"./images/ljus/ACL3605.png",
        },
        
    ] ,
    youtube_ids: ["NqdKq5P_D9A"] ,

    // technical
    dimension:'575 x 257 x 184 mm',
    vikt_1:'10 kg',

    // all cases
    all_cases:[
        {
        case_info:'För 4 st Elation ACL 360 Bar',
        vikt_2:"75 kg",
        storlek:"1100 x 640 x 470 mm",
        },
        {
        case_info:'För 8 st Elation ACL 360 Bar',
        vikt_2:"110 kg",
        storlek:"1200 x 600 x 600 cm",
        },
     ],
     
    // icons
    icons:[
        {
            icon:"./images/icons/triggerclamp.png",
            hovertext:'Trigger clamp',
        },
        {
            icon:"./images/icons/powercon.png",
            hovertext:'PowerCon',
        },
        {
            icon:"./images/icons/xlr3polv4.png",
            hovertext:'DMX 3-pol',
        },
        {
            icon:"./images/icons/xlr3polv4.png",
            hovertext:'DMX 3-pol',
        }
    ] ,
    // download
    downloadable_link:[
        {
            d_img:"./images/download.png",
            d_heading:"Elation ACL 360 Bar Manual",
            d_link:"./downloads/acl_360_bar_-_user_manual.pdf"
        },
        {
            d_img:"./images/download.png",
            d_heading:"Elation ACL 360 Bar Ritning",
            d_link:"./downloads/elation_acl_360_bar_dimensional_drawings_5.pdf"
        },
        {
            d_img:"./images/download.png",
            d_heading:"Elation ACL 360 Bar DMX Mode",
            d_link:"./downloads/elation_acl_360_bar_dmx_traits_081516_5.pdf"
        },
    ],
},
{
    id: 33601,
    category: "Moving Heads",
    product_name: "Beam Ball 100",
    level: 4,
    producer: "Stairville",
    artnr: "033-601",
    description:
      "Shure mikrofon..Line array speaker zoom range from narrow 6° beam to wide 50° wash, Uniform illumination of the light cone. Sophisticated fan management with three selectable modes: Silent, Max and Auto. Adjustable pan and tilt range with selectable start and end points. 4 Selectable dimmer curves. Adjustable PWM",
    pdf: "./../assets/manuals/Varytec.pdf",
    featured: "true",
    thumb: "./images/ljus/Beamball.png",
    //gallery images
    gallery_img:[
        {
            img:"./images/ljus/Beamball.png",
        },
        {
            img:"./images/ljus/beamball1.jpg",
        },
        {
            img:"./images/ljus/beamball2.jpg",
        },
              
    ] ,

    // technical
    dimension:'575 x 257 x 184 mm',
    vikt_1:'10 kg',

    // all cases
    all_cases:[ 
        {
        case_info:'För 4 st Elation ACL 360 Bar',
        vikt_2:"75 kg",
        storlek:"1100 x 640 x 470 mm",
        },
        {
        case_info:'För 8 st Elation ACL 360 Bar',
        vikt_2:"110 kg",
        storlek:"1200 x 600 x 600 cm",
        },
     ],
     
    // icons
    icons:[
        {
            icon:"./images/icons/triggerclamp.png",
            hovertext:'Trigger clamp',
        },
        {
            icon:"./images/icons/powercon.png",
            hovertext:'PowerCon',
        },
        {
            icon:"./images/icons/xlr3polv4.png",
            hovertext:'DMX 3-pol',
        },
        {
            icon:"./images/icons/xlr3polv4.png",
            hovertext:'DMX 3-pol',
        }
    ] ,
    // download
    downloadable_link:[
        {
            d_img:"./images/download.png",
            d_heading:"Elation ACL 360 Bar Manual",
            d_link:"./downloads/acl_360_bar_-_user_manual.pdf"
        },
        {
            d_img:"./images/download.png",
            d_heading:"Elation ACL 360 Bar Ritning",
            d_link:"./downloads/elation_acl_360_bar_dimensional_drawings_5.pdf"
        },
        {
            d_img:"./images/download.png",
            d_heading:"Elation ACL 360 Bar DMX Mode",
            d_link:"./downloads/elation_acl_360_bar_dmx_traits_081516_5.pdf"
        },
    ],
},

// BATTERILAMPOR
{
    id: 35101,
    category: "BATTERILAMPOR",
    product_name: "BBP54",
    level: 4,
    producer: "BeamZ Pro",
    artnr: "035-101",
    description:
      "BBP54 Batteridriven Uplight med  4x 12W dioder och är IP65 klassad. BBP54 är en kompakt batteridriven IP65 klassad armatur som är idealisk för användning både utomhus- och inomhus. Den är utrustad med 4x superljusa 12W RGBAW-UV-LED-lampor och har ett avtagbart inbyggt batteri som räcker i upp till 15 timmar när det är fulladdat, beroende på färger och intensitet. Den justerbara foten kan fixeras i olika vinklar för att vinkla paren. BBP54 kan kommunicera på en mängd olika sätt, med IR och trådlös DMX. Detta gör enheterna enkla att ansluta till varandra.",

      
    
all_lists:[
        {
            list_data:"Ljuskälla: 6-i-1 LED",
        },
        {
            list_data:"Färger: Röd, Grön, Blå, Amber, Vit, Ultraviolett",
        },
        {
            list_data:"LED-effekt (enskild LED): 12W",
        },
        {
            list_data:"Antal LED: 4",
        },
        {
            list_data:"Ljusstyrka: 4238 lx @ 1m",
        },
        {
            list_data:"Strålvinkel: 23 grader",
        },
        {
            list_data:"Fältvinkel: 44 grader",
        },
        {
            list_data:"Blinkfrekvens: 1-35Hz",
        },
        {
            list_data:"IP-klassning: IP54",
        },
        {
            list_data:"DMX-kanaler: 6, 12",
        },
        {
            list_data:"DMX-anslutning: Trådlös DMX",
        },
        {
            list_data:"Trådlöst DMX-protokoll: Eazylink",
        },
        {
            list_data:"Batteri: 12,6V - 7,8Ah",
        },
        {
            list_data:"Medföljande tillbehör: Fjärrkontroll (trådlös)",
        },
    ],
    
    featured: "true",
    thumb: "./images/ljus/BBP54.png",
    //gallery images
    gallery_img:[
        {
            img:"./images/ljus/BBP54.png",
        },
        {
            img:"./images/ljus/BBP54_2.png",
        },
        {
            img:"./images/ljus/BBP54_3.png",
        },
        {
            img:"./images/ljus/BBP54_4.png",
        },
        {
            img:"./images/ljus/BBP54_5.png",
        },
        {
            img:"./images/ljus/BBP54_6.jpg",
        },
           {
            img:"./images/ljus/BBP54_7.png",
        },
        {
            img:"./images/ljus/BBP54_8.png",
        },
        {
            img:"./images/ljus/BBP54_9.png",
        },
        {
            img:"./images/ljus/BBP54_10.png",
        },
                  
    ] ,
     youtube_ids: ["CbgvVbawNl0"],

    // technical
    dimension:'131x131x163 mm',
    vikt_1:'2,8 kg',
        
    // all cases
       all_cases:[ 
        {
            case_info:'För 8 st armaturer',
            vikt_2:"44 kg",
            storlek:"630 x 610 x 255 mm",
        },
    
     ],
      

     
    // icons
    icons:[
        {
            icon:"./images/icons/battery.png",
            hovertext:'Batteri',
        },
        {
            icon:"./images/icons/w-dmx.png",
            hovertext:'Wireless DMX',
        },
           {
            icon:"./images/icons/ip65.png",
            hovertext:'IP65 klassad',
        },
            {
            icon:"./images/icons/led.png",
            hovertext:'LED',
        },

    ] ,
    // download
    downloadable_link:[
        {
            d_img:"./images/download.png",
            d_heading:"BeamZ Pro BBP54 Quick Manual",
            d_link:"./downloads/BBP54-quick-manual.pdf"
        },
        {
            d_img:"./images/download.png",
            d_heading:"BeamZ Pro BBP54 Manual",
            d_link:"./downloads/BBP54-manual.pdf"
        },
        
    ],
},
// DISCOEFFEKTER
{
    id: 34201,
    category: "DISCOEFFEKTER",
    product_name: "TriPhase",
    level: 4,
    producer: "American DJ",
    artnr: "034-201",
    description:
      "Snygg ljuseffekt som täcker mycket! Skickar ut 57 skarpa strålar som rör sig.",

      
      all_lists:[
        {
            list_data:"3-pol XLR in och ut",
        },
        {
            list_data:"4 DMX kanaler",
        },
        {
            list_data:"DMX eller Stand alone (Via inbyggd mikrofon eller Auto)",
        },
        {
            list_data:"Master/Slave (i Sound active or Auto mode)",
        },
        {
            list_data:"3x3W RBG LED",
        },
        {
            list_data:"65 graders spridningsvinkel",
        },        
        {
            list_data:"Strömförbrukning 12,5W",
        },
        
    ],
    featured: "true",
    thumb: "./images/ljus/TRIphase1.png",
    //gallery images
    gallery_img:[
        {
            img:"./images/ljus/TRIphase1.png",
        },
        {
            img:"./images/ljus/TRIphase_back.png",
        },
                  
    ] ,

    // technical
    dimension:'189x306x334 mm',
    vikt_1:'4 kg',

     
    // icons
    icons:[
        {
            icon:"./images/icons/xlr3polv4.png",
            hovertext:'DMX 3-pol',
        },

    ] ,
    // download
    downloadable_link:[
        {
            d_img:"./images/download.png",
            d_heading:"American DJ TriPhase Manual",
            d_link:"./downloads/triphase.pdf"
        },
        
    ],
},

// RÖKMASKINER
{
    id: 70101,
    artnr: "070-101",
    category: "Rökmaskiner",
    product_name: "Z-1020",
    producer: "Antari",
    thumb: "./images/ljus/z1020.png",
    level: 4,
    
    //gallery images
    gallery_img:[
        {
            img:"./images/ljus/z1020.png",
        },
        {
            img:"./images/ljus/z1020_2.png",
        },        
    ] ,
},

// ÖVRIGT LJUS
{
    id: 39101,
    artnr: "032-901",
    category: "Övrigt Ljus",
    product_name: "Spegelboll 30 cm",
    producer: "",
    thumb: "./images/no_img.png",
    level: 4,
},
{
    id: 39102,
    artnr: "032-902",
    category: "Övrigt Ljus",
    product_name: "Spegelboll 40 cm",
    producer: "",
    thumb: "./images/no_img.png",
    level: 4,
},
{
    id: 39103,
    artnr: "032-903",
    category: "Övrigt Ljus",
    product_name: "Spegelboll 50 cm",
    producer: "",
    thumb: "./images/no_img.png",
    level: 4,
},

//KABEL

// Elcentraler
{
    id: 50101,
    artnr: "050-101",
    category: "Elcentraler",
    product_name: "63A PDU",
    producer: "SLDRS",
    thumb: "./images/no_img.png",
    level: 4,
},
{
    id: 50102,
    artnr: "050-XXX",
    category: "Elcentraler",
    product_name: "WPD 16A",
    producer: "Work",
    level: 4,
    description:
      "DMX övergång från 5-pol Hane tilll 3-pol hona.",
    thumb: "./images/kabel/wpd16.png",
     //gallery images
     gallery_img:[
        {
            img:"./images/kabel/wpd16.png",
        },
        {
            img:"./images/kabel/wpd16back.png",
        },
    ] ,
},
{
    id: 50103,
    artnr: "050-XXX",
    category: "Elcentraler",
    product_name: "WPD 32A",
    producer: "Work",
    level: 4,
    description:
      "DMX övergång från 5-pol Hane tilll 3-pol hona.",
    thumb: "./images/kabel/wpd32.png",
     //gallery images
     gallery_img:[
        {
            img:"./images/kabel/wpd32.png",
        },
        {
            img:"./images/kabel/wpd32back.png",
        },
    ] ,
},
{
    id: 50-201,
    artnr: "050-201",
    category: "Elcentraler",
    product_name: "32A UC",
    producer: "Malmbergs",
    level: 4,
    description:
      "Proffscentral i diskret svart färg. Svarta uttagsdon i både 1-fas & 3-fas och utrustade med indikationslampa över samtliga faser och neutralledare för att enkelt se om inkommande matning är ok. Tillverkad i slagtålig ABS-plast och säkringslucka av polykarbonat. Uttagscentral med 4 st 1-fas-uttag och 1 st CEE-uttag 32A ej avsäkrad och 1 st CEE-uttag 16A. Samtliga uttag skyddas av jordfelsbrytare. Med strömindikeringslampa.",

all_lists:[
    {
        list_data: "1 st CEE-intag 3+N+J, 32A",
    },
    {
        list_data: "1 st CEE-uttag 3+N+J (ej avsäkrat), 32A",
    },
    {
        list_data:"1 st CEE-uttag 3+N+J, 16A",
    },
    {
        list_data:"4 st 1-fas-uttag, 16A",
    },
    {
        list_data:"1 st Jordfelsbrytare 30mA, 40A",
    },
],

    thumb: "./images/kabel/UC32A.png",
     // technical
     dimension:'280x350x120 mm',
     vikt_1:'4 kg',

       // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"Kopplingsschema",
        d_link:"./downloads/UC32A.pdf"
    },
],

},

// 3-Fas kabel
{
    id: 955801,
    category: "3-Fas kabel",
    producer: "Malmbergs",
    product_name: "Grisdödare",
    thumb: "./images/kabel/grisdodare.png",
    level: 4,
    // 
    artnr: "955-301",
    description:
    "Mer info kommer",   
    
    featured: "true",

     // technical
     vikt_1:'4 kg',
  
},
{
    id: 955902,
    category: "3-Fas kabel",
    producer: "Malmbergs",
    product_name: "3-Fas kabel 16 A 2,5m",
    thumb: "./images/kabel/3faskort.png",
    level: 4,
    // 
    artnr: "955-301",
all_lists:[
    {
        list_data: "Svarta 3-Fas 16A CEE don",
    },
    {
        list_data: "RDOE (H07RN-F), 5G2,5 mm² kabel",
    },
    
],
    featured: "true",
     // technical
     vikt_1:'1,3 kg',
  
},
{
    id: 955903,
    category: "3-Fas kabel",
    producer: "Malmbergs",
    product_name: "3-Fas kabel 16 A 5m",
    thumb: "./images/kabel/3faskabel.png",
    level: 4,
    // 
    artnr: "955-301",
  all_lists:[
    {
        list_data: "Svarta 3-Fas 16A CEE don",
    },
    {
        list_data: "RDOE (H07RN-F), 5G2,5 mm² kabel",
    },
    
],
    featured: "true",
     // technical
     vikt_1:'2,2 kg',
  
},
{
    id: 955904,
    category: "3-Fas kabel",
    producer: "Malmbergs",
    product_name: "3-Fas kabel 16 A 10m",
    thumb: "./images/kabel/3faskabel.png",
    level: 4,
    // 
    artnr: "955-301",
  all_lists:[
    {
        list_data: "Svarta 3-Fas 16A CEE don",
    },
    {
        list_data: "RDOE (H07RN-F), 5G2,5 mm² kabel",
    },
    
],
    featured: "true",
     // technical
     vikt_1:'4 kg',
  
},
{
    id: 955905,
    category: "3-Fas kabel",
    producer: "Malmbergs",
    product_name: "3-Fas kabel 16 A 20m",
    thumb: "./images/kabel/3faskabel.png",
    level: 4,
    // 
    artnr: "955-301", 
all_lists:[
    {
        list_data: "Svarta 3-Fas 16A CEE don",
    },
    {
        list_data: "RDOE (H07RN-F), 5G2,5 mm² kabel",
    },
    
],
    featured: "true",
     // technical
     vikt_1:'7,8 kg',
  
},
{
    id: 95591,
    category: "3-Fas kabel",
    producer: "Malmbergs",
    product_name: "3-Fas kabel 32 A 2,5m",
    thumb: "./images/kabel/3faskort.png",
    level: 4,
    // 
    artnr: "955-301",
    all_lists:[
    {
        list_data: "Svarta 3-Fas 32A CEE don",
    },
    {
        list_data: "RDOE (H07RN-F), 5G6 mm² kabel",
    },
],
    featured: "true",
     // technical
     vikt_1:'2,2 kg',
  
},
{
    id: 955912,
    category: "3-Fas kabel",
    producer: "Malmbergs",
    product_name: "3-Fas kabel 32 A 5m",
    thumb: "./images/kabel/3faskort.png",
    level: 4,
    // 
    artnr: "955-301",
    all_lists:[
    {
        list_data: "Svarta 3-Fas 32A CEE don",
    },
    {
        list_data: "RDOE (H07RN-F), 5G6 mm² kabel",
    },
], 
    featured: "true",
     // technical
     vikt_1:'3,4 kg',
  
},
{
    id: 955913,
    category: "3-Fas kabel",
    producer: "Malmbergs",
    product_name: "3-Fas kabel 32 A 10m",
    thumb: "./images/kabel/3faskort.png",
    level: 4,
    // 
    artnr: "955-301",
   all_lists:[
    {
        list_data: "Svarta 3-Fas 32A CEE don",
    },
    {
        list_data: "RDOE (H07RN-F), 5G6 mm² kabel",
    },
],
    featured: "true",
     // technical
     vikt_1:'7,3 kg',
  
},
{
    id: 955914,
    category: "3-Fas kabel",
    producer: "Malmbergs",
    product_name: "3-Fas kabel 32 A 20m",
    thumb: "./images/kabel/3faskabel.png",
    level: 4,
    // 
    artnr: "955-301",
    all_lists:[
    {
        list_data: "Svarta 3-Fas 32A CEE don",
    },
    {
        list_data: "RDOE (H07RN-F), 5G6 mm² kabel",
    },
],
    featured: "true",
     // technical
     vikt_1:'14 kg',
  
},
{
    id: 955921,
    category: "3-Fas kabel",
    producer: "Malmbergs",
    product_name: "3-Fas kabel 63 A 2,5m",
    thumb: "./images/kabel/3faskort.png",
    level: 4,
    // 
    artnr: "955-301",
    all_lists:[
    {
        list_data: "Svarta 3-Fas 63A CEE don",
    },
    {
        list_data: "RDOE (H07RN-F), 5G16 mm² kabel",
    },
],
    featured: "true",
     // technical
     vikt_1:'?',
  
},
{
    id: 955932,
    category: "3-Fas kabel",
    producer: "Malmbergs",
    product_name: "3-Fas kabel 63 A 5m",
    thumb: "./images/kabel/3faskort.png",
    level: 4,
    // 
    artnr: "955-301",
    all_lists:[
    {
        list_data: "Svarta 3-Fas 63A CEE don",
    },
    {
        list_data: "RDOE (H07RN-F), 5G16 mm² kabel",
    },
],
    featured: "true",
     // technical
     vikt_1:'?',
  
},

//Ljudkabel
{
    id: 55110,
    artnr: "",
    category: "Ljudkabel",
    product_name: "Mikrofonkabel",
    producer: "",
    level: 4,
    description:
      "Finns i längderna",
all_lists:[
    {
        list_data: "50 cm, Omärkt, 055-050",
    },
    {
        list_data: "75 cm, Omärkt, 055-075",
    },
    {
        list_data:"1 m, Lila, 055-101",
    },
    {
        list_data:"3 m, Grön, 055-103",
    },
    {
        list_data:"5 m, Vit, 055-105",
    },
    {
        list_data:"10 m, Röd, 055-110",
    },
    {
        list_data:"20 m, Blå, 055-120",
    },

],
    thumb: "./images/kabel/dmx5to3.png",
 
    gallery_img:[
        {
            img:"./images/kabel/wpd32.png",
        },
        {
            img:"./images/kabel/wpd32back.png",
        },
    ] ,
},

//DMX

{
    id: 56555,
    artnr: "056-555",
    category: "DMX kabel",
    product_name: "DMX övergång 5 -> 3",
    producer: "",
    level: 4,
    description:
      "DMX övergång från 5-pol Hane tilll 3-pol hona.",


    thumb: "./images/kabel/dmx5to3.png",

},
{
    id: 56556,
    artnr: "056-556",
    category: "DMX kabel",
    product_name: "DMX övergång 3 -> 5",
    producer: "",
    level: 4,
    description:
      "DMX övergång från 3-pol Hane tilll 5-pol hona.",
    thumb: "./images/kabel/dmx3to5.png",

},
{
    id: 56-401,
    artnr: "056-401",
    category: "DMX kabel",
    product_name: "3-pol DMX 1 m",
    producer: "",
    level: 4,
    description:
      "3-Polig DMX kabel med XLR Neutrikdon och Cordial kabel.",
    thumb: "./images/no_img.png",
},
{
    id: 56403,
    artnr: "056-403",
    category: "DMX kabel",
    product_name: "3-pol DMX 3 m",
    producer: "",
    level: 4,
    description:
      "3-Polig DMX kabel med XLR Neutrikdon och Cordial kabel.",
    thumb: "./images/no_img.png",
},
{
    id: 56-403,
    artnr: "056-403",
    category: "DMX kabel",
    product_name: "3-pol DMX 3 m",
    producer: "",
    level: 4,
    description:
      "3-Polig DMX kabel med XLR Neutrikdon och Cordial kabel.",
    thumb: "./images/no_img.png",
},

// BNC kabel
{
    id: 57-403,
    artnr: "056-403",
    category: "BNC kabel",
    product_name: "Antennkabel 0,5 m",
    producer: "",
    level: 4,
    description:
      "BNC kabel används till antennkabel till t.ex. trådlös mikrofonsystemen",
    thumb: "./images/kabel/bnc.png",
},


// Kabelskydd
{
    id: 59901,
    artnr: "059-901",
    category: "Kabelskydd",
    product_name: "Defender mini",
    producer: "Adam Hall",
    level: 4,
    description:
      "Kabelskydd",
     
          all_lists:[
    {
        list_data: "Svarta med gula överdel",
    },
    {
        list_data: "3 kanaler (2 st 35 x 30 mm, 1 st 35 x 35 mm) ",
    },
    {
        list_data: "Bärighet 2 Ton på en yta 20 x 20 cm",
    },
],
    thumb: "./images/kabel/defender.png",
    // technical
    dimension:'1000 x 290 x 50 mm',
    vikt_1:'5 kg',

},
{
    id: 59902,
    artnr: "059-902",
    category: "Kabelskydd",
    product_name: "Defender mini female",
    producer: "Adam Hall",
    level: 4,
    description:
      "Avslut för att få ett snyggare avslut på kabelskyddet",
    thumb: "./images/kabel/defenderfemale.png",
},
{
    id: 59903,
    artnr: "059-903",
    category: "Kabelskydd",
    product_name: "Defender mini hane",
    producer: "Adam Hall",
    level: 4,
    description:
      "Avslut för att få ett snyggare avslut på kabelskyddet",
    thumb: "./images/kabel/defendermale.png",
},
{
    id: 59904,
    artnr: "059-901",
    category: "Kabelskydd",
    product_name: "Defender mini 135 corner",
    producer: "Adam Hall",
    level: 4,
    description:
      "En 135 graders böj till kabelskyddet",
    thumb: "./images/kabel/defender135.png",
},



// RIGGING

// LYFTREDSKAP
{
    id: 60101,
    category: "Lyftredskap",
    producer: "Arno",
    product_name: "Handspel 250 kg 5 m ",
    thumb: "./images/rigging/handspel.png",
    level: 4,
    //
    artnr: "060-101",
    description:
    "",  


    all_lists:[
        {
            list_data: "Handspel 250 kg",
        },
        {
            list_data: "Lyfthöjd: 5 m",
        },
        {
            list_data:"Medföljande kättingpåse",
        },
        
    ],
    featured: "true",
 
},
{
    id: 60105,
    category: "Lyftredskap",
    producer: "Arno",
    product_name: "Handspel 500 kg 8 m ",
    thumb: "./images/rigging/handspel.png",
    level: 4,
    //
    artnr: "060-105",
    description:
    "",  


    all_lists:[
        {
            list_data: "Handspel 500 kg",
        },
        {
            list_data: "Lyfthöjd: 8 m",
        },
        {
            list_data:"Kättingpåse medföljer",
        },
        
    ],
    featured: "true",
 
},
{
    id: 60201,
    category: "Lyftredskap",
    producer: "Work",
    product_name: "LW155R Black",
    thumb: "./images/rigging/LW155R.png",
    level: 4,
    //
    artnr: "060-201",
    description:
    "",  


    all_lists:[
        {
            list_data: "Handspel 250 kg",
        },
        {
            list_data: "Lyfthöjd: 5 m",
        },
        {
            list_data:"Medföljande kättingpåse",
        },
        
    ],
    featured: "true",
 
},
{
    id: 60211,
    category: "Lyftredskap",
    producer: "Manfrotto",
    product_name: "087 Black",
    thumb: "./images/rigging/manfrotto087.png",
    level: 4,
    //
    artnr: "060-211",
    description:
    "",  


    all_lists:[
        {
            list_data: "Handspel 250 kg",
        },
        {
            list_data: "Lyfthöjd: 5 m",
        },
        {
            list_data:"Medföljande kättingpåse",
        },
        
    ],
    featured: "true",
 
},
{
    id: 60221,
    category: "Lyftredskap",
    producer: "Manfrotto",
    product_name: "111 Black",
    thumb: "./images/rigging/Manfrotto111.png",
    level: 4,
    //
    artnr: "060-221",
    description:
    "",  


    all_lists:[
        {
            list_data: "Handspel 250 kg",
        },
        {
            list_data: "Lyfthöjd: 5 m",
        },
        {
            list_data:"Medföljande kättingpåse",
        },
        
    ],
    featured: "true",
 
},
{
    id: 60231,
    category: "Lyftredskap",
    producer: "Manfrotto",
    product_name: "004 Black",
    thumb: "./images/rigging/manfrotto004.png",
    level: 4,
    //
    artnr: "060-231",
    description:
    "",  


    all_lists:[
        {
            list_data: "Handspel 250 kg",
        },
        {
            list_data: "Lyfthöjd: 5 m",
        },
        {
            list_data:"Medföljande kättingpåse",
        },
        
    ],
    featured: "true",
 
},
{
    id: 60200,
    category: "Lyftredskap",
    producer: "Global Truss",
    product_name: "GIZMO",
    thumb: "./images/rigging/gizmo.png",
    level: 4,
    //
    artnr: "060-XXX",
    description:
    "",  


    all_lists:[
        {
            list_data: "Istället för att slinga truss.",
        },
        {
            list_data: "Håldiameter: 25mm",
        },
        {
            list_data:"Last 1500 kg / WLL och 750 kg över människor",
        },
        {
            list_data:"Passar till F33 / F34 Truss",
        },
    ],
    featured: "true",
 
},
{
    id: 60222,
    category: "Lyftredskap",
    producer: "Reutlinger",
    product_name: "50 SVIII Ring",
    thumb: "./images/rigging/reutlinger.png",
    level: 4,
    //
    artnr: "060-XXX",
    description:
    "",  


    all_lists:[
        {
            list_data: "SWL:5 mm wire 90 Kg",
        },
        {
            list_data: "Ringdiameter: 54 mm",
        },
        {
            list_data:"Innerdiameter: 30 mm",
        },
        
    ],
    featured: "true",
 
},
{
    id: 60299,
    category: "Lyftredskap",
    producer: "Arno remmen",
    product_name: "Schackel 3,25 Ton",
    thumb: "./images/rigging/schackel.png",
    level: 4,
    //
    artnr: "060-XXX",
    description:
    "WLL 3,25 Ton",  


    all_lists:[
        
        
    ],
    featured: "true",
 
},


//F31
{
    id: 61050,
    category: "F31 Truss",
    producer: "Global Truss",
    product_name: "F31 50 cm Black",
    thumb: "./images/rigging/F31050B.png",
    level: 4,
    artnr: "061-050",
    description:
    "Levereras med koner, sprint och R-clips",   
    
    featured: "true",
     //gallery images
     

     // technical
     dimension:'500 x 50 x 50 mm',
     vikt_1:'1,1 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'',
        vikt_2:"",
        storlek:"",
    },

 ],
  
    
  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"F31 Datablad",
        d_link:"./downloads/F31datablad.pdf"
    },
   
],
},
{
    id: 61051,
    category: "F31 Truss",
    producer: "Global Truss",
    product_name: "F31 50 cm Alu",
    thumb: "./images/rigging/F31050A.png",
    level: 4,
    // 
    artnr: "061-050A",
    description:
    "Levereras med koner, sprint och R-clips",   
    
    featured: "true",
     //gallery images
     

     // technical
     dimension:'500 x 50 x 50 mm',
     vikt_1:'1,1 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'',
        vikt_2:"",
        storlek:"",
    },

 ],
  
    
  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"F31 Datablad",
        d_link:"./downloads/F31datablad.pdf"
    },
   
],
},
{
    id: 61100,
    category: "F31 Truss",
    producer: "Global Truss",
    product_name: "F31 100 cm Black",
    thumb: "./images/rigging/F31100B.png",
    level: 4,
    // 
    artnr: "061-100",
    description:
    "Levereras med koner, sprint och R-clips",   
    
    featured: "true",
     //gallery images
     

     // technical
     dimension:'1000 x 50 x 50 mm',
     vikt_1:'1,4 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'',
        vikt_2:"",
        storlek:"",
    },

 ],
  
    
  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"F31 Datablad",
        d_link:"./downloads/F31datablad.pdf"
    },
   
],
},
{
    id: 61101,
    category: "F31 Truss",
    producer: "Global Truss",
    product_name: "F31 100 cm Alu",
    thumb: "./images/rigging/F31100A.png",
    level: 4,
    // 
    artnr: "061-101A",
    description:
    "Levereras med koner, sprint och R-clips",   
    
    featured: "true",
     //gallery images
     

     // technical
     dimension:'1000 x 50 x 50 mm',
     vikt_1:'1,4 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'',
        vikt_2:"",
        storlek:"",
    },

 ],
  
    
  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"F31 Datablad",
        d_link:"./downloads/F31datablad.pdf"
    },
   
],
},
{
    id: 61150,
    category: "F31 Truss",
    producer: "Global Truss",
    product_name: "F31 150 cm Black",
    thumb: "./images/rigging/F31150B.png",
    level: 4,
    // 
    artnr: "061-150",
    description:
    "Levereras med koner, sprint och R-clips",   
    
    featured: "true",
     //gallery images
     

     // technical
     dimension:'1500 x 50 x 50 mm',
     vikt_1:'1,9 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'',
        vikt_2:"",
        storlek:"",
    },

 ],
  
    
  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"F31 Datablad",
        d_link:"./downloads/F31datablad.pdf"
    },
   
],
},
{
    id: 61151,
    category: "F31 Truss",
    producer: "Global Truss",
    product_name: "F31 150 cm Alu",
    thumb: "./images/rigging/F31150A.png",
    level: 4,
    // 
    artnr: "061-150A",
    description:
    "Levereras med koner, sprint och R-clips",   
    
    featured: "true",
     //gallery images
     

     // technical
     dimension:'1500 x 50 x 50 mm',
     vikt_1:'1,9 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'',
        vikt_2:"",
        storlek:"",
    },

 ],
  
    
  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"F31 Datablad",
        d_link:"./downloads/F31datablad.pdf"
    },
   
],
},
{
    id: 61200,
    category: "F31 Truss",
    producer: "Global Truss",
    product_name: "F31 200 cm Black",
    thumb: "./images/rigging/F31200B.png",
    level: 4,
    // 
    artnr: "061-200",
    description:
    "Levereras med koner, sprint och R-clips",   
    
    featured: "true",
     //gallery images
     

     // technical
     dimension:'2000 x 50 x 50 mm',
     vikt_1:'2,4 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'',
        vikt_2:"",
        storlek:"",
    },

 ],
  
    
  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"F31 Datablad",
        d_link:"./downloads/F31datablad.pdf"
    },
   
],
},
{
id: 61201,
category: "F31 Truss",
producer: "Global Truss",
product_name: "F31 200 cm Alu",
thumb: "./images/rigging/F31200A.png",
level: 4,
// 
artnr: "061-200A",
description:
"Levereras med koner, sprint och R-clips",   

featured: "true",
 //gallery images
 

 // technical
 dimension:'2000 x 50 x 50 mm',
 vikt_1:'2,4 kg',

// all cases
all_cases:[ 
{
    case_info:'',
    vikt_2:"",
    storlek:"",
},

],


// download
downloadable_link:[
{
    d_img:"./images/download.png",
    d_heading:"F31 Datablad",
    d_link:"./downloads/F31datablad.pdf"
},

],
},
{
    id: 61300,
    category: "F31 Truss",
    producer: "Global Truss",
    product_name: "F31 300 cm Black",
    thumb: "./images/rigging/F31300B.png",
    level: 4,
    // 
    artnr: "061-300",
    description:
    "Levereras med koner, sprint och R-clips",   
    
    featured: "true",
     //gallery images
     

     // technical
     dimension:'3000 x 50 x 50 mm',
     vikt_1:'3 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'',
        vikt_2:"",
        storlek:"",
    },

 ],
  
    
  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"F31 Datablad",
        d_link:"./downloads/F31datablad.pdf"
    },
   
],
},
{
    id: 61601,
    category: "F31 Truss",
    producer: "Global Truss",
    product_name: "F31 Truss cube Black",
    thumb: "./images/rigging/F31cubeB.png",
    level: 4,
    // 
    artnr: "061-600",
    description:
    "Levereras med koner, sprint och R-clips",   
    
    featured: "true",
     //gallery images
     

     // technical
     dimension:'50 x 50 x 50 mm',
     vikt_1:'0,8 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'',
        vikt_2:"",
        storlek:"",
    },

 ],
  
    
  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"F31 Datablad",
        d_link:"./downloads/F31datablad.pdf"
    },
   
],
},
{
    id: 61602,
    category: "F31 Truss",
    producer: "Global Truss",
    product_name: "F31 Truss cube Alu",
    thumb: "./images/rigging/F31cubeA.png",
    level: 4,
    // 
    artnr: "061-600A",
    description:
    "Levereras med koner, sprint och R-clips",   
    
    featured: "true",
     //gallery images
     

     // technical
     dimension:'50 x 50 x 50 mm',
     vikt_1:'0,8 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'',
        vikt_2:"",
        storlek:"",
    },

 ],
  
    
  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"F31 Datablad",
        d_link:"./downloads/F31datablad.pdf"
    },
   
],
},
{
    id: 61635,
    category: "F31 Truss",
    producer: "Global Truss",
    product_name: "F31 135° Truss Cube Black",
    thumb: "./images/rigging/F31cube135B.png",
    level: 4,
    // 
    artnr: "061-635",
    description:
    "Levereras med koner, sprint och R-clips",   
    
    featured: "true",
     //gallery images
     

     // technical
     dimension:'500 x 50 x 50 mm',
     vikt_1:'1,1 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'',
        vikt_2:"",
        storlek:"",
    },

 ],
  
    
  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"F31 Datablad",
        d_link:"./downloads/F31datablad.pdf"
    },
   
],
},

//F32
{
    id: 62050,
    category: "F32 Truss",
    producer: "Global Truss",
    product_name: "F32 50 cm Black",
    thumb: "./images/rigging/F32050.png",
    level: 4,
    // 
    artnr: "062-050",
    description:
    "Levereras med koner, sprint och R-clips",   
    
    featured: "true",
     //gallery images
     

     // technical
     dimension:'500 x 50 x 290 mm',
     vikt_1:'1,7 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'',
        vikt_2:"",
        storlek:"",
    },

 ],
  
    
  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"F32 Datablad",
        d_link:"./downloads/F32datablad.pdf"
    },
   
],
},
{
    id: 62075,
    category: "F32 Truss",
    producer: "Global Truss",
    product_name: "F32 75 cm Black",
    thumb: "./images/rigging/F32075B.png",
    level: 4,
    // 
    artnr: "062-075",
    description:
    "Levereras med koner, sprint och R-clips",   
    
    featured: "true",
     //gallery images
     

     // technical
     dimension:'750 x 50 x 290 mm',
     vikt_1:'2,1 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'',
        vikt_2:"",
        storlek:"",
    },

 ],
  
    
  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"F32 Datablad",
        d_link:"./downloads/F32datablad.pdf"
    },
   
],
},
{
    id: 62100,
    category: "F32 Truss",
    producer: "Global Truss",
    product_name: "F32 100 cm Black",
    thumb: "./images/rigging/F32100B.png",
    level: 4,
    // 
    artnr: "062-100",
    description:
    "Levereras med koner, sprint och R-clips",   
    
    featured: "true",
     //gallery images
     

     // technical
     dimension:'1000 x 50 x 290 mm',
     vikt_1:'2,5 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'',
        vikt_2:"",
        storlek:"",
    },

 ],
  
    
  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"F32 Datablad",
        d_link:"./downloads/F32datablad.pdf"
    },
   
],
},
{
    id: 62150,
    category: "F32 Truss",
    producer: "Global Truss",
    product_name: "F32 150 cm Black",
    thumb: "./images/rigging/F32150B.png",
    level: 4,
    // 
    artnr: "062-150",
    description:
    "Levereras med koner, sprint och R-clips",   
    
    featured: "true",
     //gallery images
     

     // technical
     dimension:'1500 x 50 x 290 mm',
     vikt_1:'3,5 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'',
        vikt_2:"",
        storlek:"",
    },

 ],
  
    
  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"F32 Datablad",
        d_link:"./downloads/F32datablad.pdf"
    },
   
],
},
{
    id: 62200,
    category: "F32 Truss",
    producer: "Global Truss",
    product_name: "F32 200 cm Black",
    thumb: "./images/rigging/F32200B.png",
    level: 4,
    // 
    artnr: "062-200",
    description:
    "Levereras med koner, sprint och R-clips",   
    
    featured: "true",
     //gallery images
     

     // technical
     dimension:'2000 x 50 x 290 mm',
     vikt_1:'4,6 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'',
        vikt_2:"",
        storlek:"",
    },

 ],
  
    
  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"F32 Datablad",
        d_link:"./downloads/F32datablad.pdf"
    },
   
],
},
{
    id: 62300,
    category: "F32 Truss",
    producer: "Global Truss",
    product_name: "F32 300 cm Black",
    thumb: "./images/rigging/F32300B.png",
    level: 4,
    // 
    artnr: "062-300",
    description:
    "Levereras med koner, sprint och R-clips",   
    
    featured: "true",
     //gallery images
     

     // technical
     dimension:'3000 x 50 x 290 mm',
     vikt_1:'6,7 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'',
        vikt_2:"",
        storlek:"",
    },

 ],
  
    
  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"F32 Datablad",
        d_link:"./downloads/F32datablad.pdf"
    },
   
],
},
{
    id: 62601,
    category: "F32 Truss",
    producer: "Global Truss",
    product_name: "F32 Dogbone Cornerbox",
    thumb: "./images/rigging/F32dogbone.png",
    level: 4,
    // 
    artnr: "062-601",
    description:
    "Levereras med koner, sprint och R-clips",   
    
    featured: "true",
     //gallery images
     

     // technical
     dimension:'50 x 50 x 290 mm',
     vikt_1:'1,2 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'',
        vikt_2:"",
        storlek:"",
    },

 ],
  
    
  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"F32 Datablad",
        d_link:"./downloads/F32datablad.pdf"
    },
   
],
},
{
    id: 62602,
    category: "F32 Truss",
    producer: "Global Truss",
    product_name: "F32 > F34 Adapter",
    thumb: "./images/rigging/F32adapter.png",
    level: 4,
    // 
    artnr: "062-602",
    description:
    "Levereras med koner, sprint och R-clips",   
    
    featured: "true",
     //gallery images
     

     // technical
     dimension:'290 x 50 x 290 mm',
     vikt_1:'2 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'',
        vikt_2:"",
        storlek:"",
    },

 ],
  
    
  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"F32 Datablad",
        d_link:"./downloads/F32datablad.pdf"
    },
   
],
},
{
    id: 62635,
    category: "F32 Truss",
    producer: "Global Truss",
    product_name: "F32 135° graders hörn",
    thumb: "./images/rigging/F32135deg.png",
    level: 4,
    // 
    artnr: "062-635",
    description:
    "Levereras med koner, sprint och R-clips",   
    
    featured: "true",
     //gallery images
     

     // technical
     dimension:'900 x 50 x 290 mm',
     vikt_1:'2,8 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'',
        vikt_2:"",
        storlek:"",
    },

 ],
  
    
  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"F32 Datablad",
        d_link:"./downloads/F32datablad.pdf"
    },
   
],
},

//F34
{
    id: 64021,
    category: "F34 Truss",
    producer: "Global Truss",
    product_name: "F34 21 cm Black",
    thumb: "./images/rigging/F34021B.png",
    level: 4,
    // 
    artnr: "064-021",
    description:
    "Levereras med koner, sprint och R-clips",   
    
    featured: "true",
     //gallery images
    

     // technical
     dimension:'210 x 290 x 290 mm',
     vikt_1:'2,5 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'',
        vikt_2:"",
        storlek:"",
    },

 ],

  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"Global Truss F34 Datablad",
        d_link:"./downloads/datablad_F34.pdf"
    },
   
],
},
{
    id: 64025,
    category: "F34 Truss",
    producer: "Global Truss",
    product_name: "F34 25 cm Black",
    thumb: "./images/rigging/F34025B.png",
    level: 4,
    // 
    artnr: "064-025",
    description:
    "Levereras med koner, sprint och R-clips",   
    
    featured: "true",
     //gallery images
    

     // technical
     dimension:'250 x 290 x 290 mm',
     vikt_1:'2,9 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'',
        vikt_2:"",
        storlek:"",
    },

 ],

  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"Global Truss F34 Datablad",
        d_link:"./downloads/datablad_F34.pdf"
    },
   
],
},
{
    id: 64050,
    category: "F34 Truss",
    producer: "Global Truss",
    product_name: "F34 50 cm Black",
    thumb: "./images/rigging/F34050.png",
    level: 4,
    // 
    artnr: "064-050",
    description:
    "Levereras med koner, sprint och R-clips",   
    
    featured: "true",
     //gallery images
    

     // technical
     dimension:'500 x 290 x 290 mm',
     vikt_1:'4,9 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'',
        vikt_2:"",
        storlek:"",
    },

 ],

  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"Global Truss F34 Datablad",
        d_link:"./downloads/datablad_F34.pdf"
    },
   
],
},
{
    id: 64075,
    category: "F34 Truss",
    producer: "Global Truss",
    product_name: "F34 75 cm Black",
    thumb: "./images/rigging/F34050.png",
    level: 4,
    // 
    artnr: "064-075",
    description:
    "Levereras med koner, sprint och R-clips",   
    
    featured: "true",
     //gallery images
    

     // technical
     dimension:'750 x 290 x 290 mm',
     vikt_1:'7 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'',
        vikt_2:"",
        storlek:"",
    },

 ],

  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"Global Truss F34 Datablad",
        d_link:"./downloads/datablad_F34.pdf"
    },
   
],
},
{
    id: 64100,
    category: "F34 Truss",
    producer: "Global Truss",
    product_name: "F34 100 cm Black",
    thumb: "./images/rigging/F34100B.png",
    level: 4,
    // 
    artnr: "064-100",
    description:
    "Levereras med koner, sprint och R-clips",   
    
    featured: "true",
     //gallery images
    

     // technical
     dimension:'1000 x 290 x 290 mm',
     vikt_1:'7,5 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'Hjulplatta för truss',
        vikt_2:"5 kg",
        storlek:"",
    },

 ],

  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"Global Truss F34 Datablad",
        d_link:"./downloads/datablad_F34.pdf"
    },
   
],
},
{
    id: 64150,
    category: "F34 Truss",
    producer: "Global Truss",
    product_name: "F34 150 cm Black",
    thumb: "./images/rigging/F34150B.png",
    level: 4,
    // 
    artnr: "064-150",
    description:
    "Levereras med koner, sprint och R-clips",   
    
    featured: "true",
     //gallery images
    

     // technical
     dimension:'1500 x 290 x 290 mm',
     vikt_1:'9,7 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'Hjulplatta för truss',
        vikt_2:"5 kg",
        storlek:"",
    },

 ],

  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"Global Truss F34 Datablad",
        d_link:"./downloads/datablad_F34.pdf"
    },
   
],
},
{
    id: 64200,
    category: "F34 Truss",
    producer: "Global Truss",
    product_name: "F34 200 cm Black",
    thumb: "./images/rigging/F34200B.png",
    level: 4,
    // 
    artnr: "064-200",
    description:
    "Levereras med koner, sprint och R-clips",   
    
    featured: "true",
     //gallery images
    

     // technical
     dimension:'2000 x 290 x 290 mm',
     vikt_1:'12 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'Hjulplatta för truss',
        vikt_2:"5 kg",
        storlek:"",
    },

 ],

  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"Global Truss F34 Datablad",
        d_link:"./downloads/datablad_F34.pdf"
    },
   
],
},
{
    id: 64300,
    category: "F34 Truss",
    producer: "Global Truss",
    product_name: "F34 300 cm Black",
    thumb: "./images/rigging/F34300B.png",
    level: 4,
    // 
    artnr: "064-300",
    description:
    "Levereras med koner, sprint och R-clips",   
    
    featured: "true",
     //gallery images
    

     // technical
     dimension:'3000 x 290 x 290 mm',
     vikt_1:'16 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'Hjulplatta för truss',
        vikt_2:"5 kg",
        storlek:"",
    },

 ],

  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"Global Truss F34 Datablad",
        d_link:"./downloads/datablad_F34.pdf"
    },
   
],
},
{
    id: 64601,
    category: "F34 Truss",
    producer: "Global Truss",
    product_name: "F34 Cornerbox",
    thumb: "./images/rigging/F34box.png",
    level: 4,
    // 
    artnr: "064-601",
        
    description:
    "Cornerbox byggs enkelt till det hörn du önskar. Vi har en rad olika tillbehör för att kunna skapa det hörn du behöver, från ett 90 graders hörn till ett 6-vägs hörn",   
    
    featured: "true",
     //gallery images
    

     // technical
     dimension:'290 x 290 x 290 mm',
     vikt_1:'5,7 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'',
        vikt_2:"",
        storlek:"",
    },

 ],

  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"Global Truss F34 Datablad",
        d_link:"./downloads/datablad_F34.pdf"
    },
   
],
},
{
    id: 64645,
    category: "F34 Truss",
    producer: "Global Truss",
    product_name: "F34 135° graders hörn",
    thumb: "./images/rigging/F34135deg.png",
    level: 4,
    // 
    artnr: "064-645",
    description:
    "Levereras med koner, sprint och R-clips.",   
    
    featured: "true",
     //gallery images
    

     // technical
     dimension:'900 x 290 x 290 mm',
     vikt_1:'6 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'',
        vikt_2:"",
        storlek:"",
    },

 ],

  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"Global Truss F34 Datablad",
        d_link:"./downloads/datablad_F34.pdf"
    },
   
],
},
{
    id: 64701,
    category: "F34 Truss",
    producer: "Global Truss",
    product_name: "F34 Rörtopp",
    thumb: "./images/rigging/F34toptube.png",
    level: 4,
    // 
    artnr: "064-701",
    all_lists:[
        {
            list_data:"Levereras med koner, sprint och R-clips.",
        },
        {
            list_data:"Använs för att fästa t.ex lampa ovanpå Trussen",
        },
    ],

    
    featured: "true",
     //gallery images
    

     // technical
     dimension:'500 x 290 x 290 mm',
     vikt_1:'2,7 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'',
        vikt_2:"",
        storlek:"",
    },

 ],

  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"Global Truss F34 Datablad",
        d_link:"./downloads/datablad_F34.pdf"
    },
   
],
},

//Ground Support
{
    id: 65001,
    category: "Ground Support",
    producer: "Global Truss",
    product_name: "Komplett Ground Support torn",
    thumb: "./images/rigging/F34towerv2.png",
    level: 4,
    // 
    artnr: "065-001",
    description:
    "Komplett system",   
    all_lists:[
        {
            list_data:"1 st F34 Tower Top",
        },
        {
            list_data:"1 st F34 Sleeve Block",
        },
        {
            list_data:"1 st F34 Ground support base",
        },
        {
            list_data:"Outriggers enligt önskemål",
        },
        {
            list_data:"4 Justerbara fötter till Ground Support Base",
        },
        {
            list_data:"X st Justerbara fötter till Outriggers",
        },
        {
            list_data:"2 st Gångjärn Höger",
        },
        {
            list_data:"2 st Gångjärn Vänster",
        },
        {
            list_data:"1 st F34 50 cm Black ",
        },
    ],
    
    featured: "true",
     //gallery images
     gallery_img:[
        {
            img:"./images/rigging/F34towerv2.png",
        },
        {
            img:"./images/rigging/F34towertop.png",
        },
        {
            img:"./images/rigging/F34sleeve.png",
        },
        
       
    ] ,

     // technical
     dimension:'',
     vikt_1:'',

   // all cases
   all_cases:[ 
    {
        case_info:'',
        vikt_2:"",
        storlek:"",
    },

 ],
  
    // icons
    icons:[
           
      
    ] ,

  // download
  downloadable_link:[
 
   
],
},
{
    id: 65101,
    category: "Ground Support",
    producer: "Global Truss",
    product_name: "F34 Tower Top",
    thumb: "./images/rigging/F34towertop.png",
    level: 4,
    // 
    artnr: "065-101",
    description:
    "Komplett system",   
    
    featured: "true",
     //gallery images
     gallery_img:[
        {
            img:"./images/ljus/slimpar36.png",
        },
        {
            img:"./images/ljus/slimpar36_back.png",
        },
        
       
    ] ,

     // technical
     dimension:'500 x 50 x 290 mm',
     vikt_1:'1 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'För 8 st Pro SLim Par',
        vikt_2:"64 kg",
        storlek:"900 x 600 x 600 mm",
    },

 ],
  
    // icons
    icons:[
        {
            icon:"./images/icons/powercon.png",
            hovertext:'PowerCon',
        },
        {
            icon:"./images/icons/led.png",
            hovertext:'LED lampa',
        },
        {
            icon:"./images/icons/wwcw.png",
            hovertext:'Varm/Kall vit',
        },
        
        {
            icon:"./images/icons/xlr3polv4.png",
            hovertext:'XLR 3-pol',
        },
      
      
    ] ,

  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"Futurelight Pro Slim Par 36 manual",
        d_link:"./downloads/slimpar36.pdf"
    },
   
],
},
{
    id: 65102,
    category: "Ground Support",
    producer: "Global Truss",
    product_name: "F34 Sleeve block",
    thumb: "./images/rigging/F34sleeve.png",
    level: 4,
    // 
    artnr: "065-102",
    description:
    "Komplett system",   
    
    featured: "true",
     //gallery images
     gallery_img:[
        {
            img:"./images/ljus/slimpar36.png",
        },
        {
            img:"./images/ljus/slimpar36_back.png",
        },
        
       
    ] ,

     // technical
     dimension:'500 x 50 x 290 mm',
     vikt_1:'1 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'För 8 st Pro SLim Par',
        vikt_2:"64 kg",
        storlek:"900 x 600 x 600 mm",
    },

 ],
  
    // icons
    icons:[
        {
            icon:"./images/icons/powercon.png",
            hovertext:'PowerCon',
        },
        {
            icon:"./images/icons/led.png",
            hovertext:'LED lampa',
        },
        {
            icon:"./images/icons/wwcw.png",
            hovertext:'Varm/Kall vit',
        },
        
        {
            icon:"./images/icons/xlr3polv4.png",
            hovertext:'XLR 3-pol',
        },
      
      
    ] ,

  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"Futurelight Pro Slim Par 36 manual",
        d_link:"./downloads/slimpar36.pdf"
    },
   
],
},
{
    id: 65103,
    category: "Ground Support",
    producer: "Global Truss",
    product_name: "F34 Ground Support Base",
    thumb: "./images/rigging/F34base.png",
    level: 4,
    // 
    artnr: "065-103",
    description:
    "Komplett system",   
    
    featured: "true",
     //gallery images
     gallery_img:[
        {
            img:"./images/ljus/slimpar36.png",
        },
        {
            img:"./images/ljus/slimpar36_back.png",
        },
        
       
    ] ,

     // technical
     dimension:'500 x 50 x 290 mm',
     vikt_1:'1 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'För 8 st Pro SLim Par',
        vikt_2:"64 kg",
        storlek:"900 x 600 x 600 mm",
    },

 ],
  
    // icons
    icons:[
        {
            icon:"./images/icons/powercon.png",
            hovertext:'PowerCon',
        },
        {
            icon:"./images/icons/led.png",
            hovertext:'LED lampa',
        },
        {
            icon:"./images/icons/wwcw.png",
            hovertext:'Varm/Kall vit',
        },
        
        {
            icon:"./images/icons/xlr3polv4.png",
            hovertext:'XLR 3-pol',
        },
      
      
    ] ,

  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"Futurelight Pro Slim Par 36 manual",
        d_link:"./downloads/slimpar36.pdf"
    },
   
],
},
{
    id: 65111,
    artnr: "065-111",
    category: "Ground Support",
    product_name: "Gångjärn höger",
    thumb: "./images/ljud/right.png",
    producer: "Global Truss",
    level: 4
},
{
    id: 65112,
    artnr: "065-112",
    category: "Ground Support",
    product_name: "Gångjärn Vänster",
    thumb: "./images/ljud/vänster.png",
    producer: "Global Truss",
    level: 4
},
{
    id: 65131,
    artnr: "065-131",
    category: "Ground Support",
    product_name: "Outrigger 50 cm",
    thumb: "./images/ljud/outrigger50.png",
    producer: "Global Truss",
    level: 4
},
{
    id: 65132,
    artnr: "065-132",
    category: "Ground Support",
    product_name: "Outrigger 75 cm",
    thumb: "./images/ljud/outrigger75.png",
    producer: "Global Truss",
    level: 4
},
{
    id: 65133,
    artnr: "065-133",
    category: "Ground Support",
    product_name: "Outrigger 150 cm",
    thumb: "./images/ljud/outrigger150.png",
    producer: "Global Truss",
    level: 4
},
{
    id: 65135,
    artnr: "065-135",
    category: "Ground Support",
    product_name: "Outrigger Ballast",
    thumb: "./images/ljud/outriggerballast.png",
    producer: "Global Truss",
    level: 4
},
{
    id: 69990,
    artnr: "065-112",
    category: "Ground Support",
    product_name: "F32 Golvplatta",
    thumb: "./images/truss/.png",
    producer: "Global Truss",
    level: 4
},
{
    id: 69991,
    artnr: "065-112",
    category: "Ground Support",
    product_name: "F34 Golvplatta 30 x 30 cm",
    thumb: "./images/ljud/vänster.png",
    producer: "Global Truss",
    level: 4
},
{
    id: 69993,
    artnr: "065-112",
    category: "Ground Support",
    product_name: "Golvplatta 450 mm",
    thumb: "./images/rigging/.png",
    producer: "Global Truss",
    level: 4
},
{
    id: 69994,
    artnr: "065-112",
    category: "Ground Support",
    product_name: "Golvplatta 60 cm",
    thumb: "./images/rigging/600golv.png",
    producer: "Global Truss",
    level: 4
},
{
    id: 69995,
    artnr: "065-112",
    category: "Ground Support",
    product_name: "F34 Spindelfot",
    thumb: "./images/ljud/vänster.png",
    producer: "Global Truss",
    level: 4
},

// Specialdelar
{
    id: 6599,
    category: "Specialdelar",
    producer: "Global Truss",
    product_name: "Vänstervriden kon",
    thumb: "./images/rigging/konleft.png",
    level: 4,
    // 
    artnr: "065-601",
    featured: "true",
},
{
    id: 6598,
    category: "Specialdelar",
    producer: "Global Truss",
    product_name: "Högervriden kon",
    thumb: "./images/rigging/konright.png",
    level: 4,
    // 
    artnr: "065-601",
    featured: "true",
},
{
    id: 65601,
    category: "Specialdelar",
    producer: "Global Truss",
    product_name: "F34 Burton med tapp",
    thumb: "./images/rigging/burtonF31.png",
    level: 4,
    // 
    artnr: "065-601",
    featured: "true",
   
},
{
    id: 65602,
    category: "Specialdelar",
    producer: "Global Truss",
    product_name: "F34 Burton med 50 mm F31",
    thumb: "./images/rigging/burton50mm.png",
    level: 4,
    // 
    artnr: "065-602",
    featured: "true",
   
},
{
    id: 65997,
    category: "Specialdelar",
    producer: "Global Truss",
    product_name: "50 mm distans",
    thumb: "./images/rigging/50mmdistans.png",
    level: 4,
    // 
    artnr: "065-601",
    featured: "true",
   
},

// ÖVRIG RIGGING
{
    id: 69996,
    artnr: "065-112",
    category: "Övrig Rigging",
    product_name: "BigBen",
    thumb: "./images/rigging/bigben.png",
    producer: "Doughty",
    level: 4
},
{
    id: 69997,
    artnr: "065-112",
    category: "Övrig Rigging",
    product_name: "Trussadapter",
    thumb: "./images/rigging/trussadapter.png",
    producer: "Doughty",
    level: 4
},



// ÖVRIGT

// NÄTVERK
{
    id: 87994,
    artnr: "065-115",
    category: "Nätverk",
    product_name: "TL-SG105PE",
    thumb: "./images/diverse/tplink.png",
    producer: "TP Link",
    level: 4,
    description:
    "TP-Link TL-SG105PE är en PoE-switch med manageringsmöjligheter och 5 gigabitportar. Portarna leverar upp till 30 W vardera med en total effekt på max. 65 W.",
},
{
    id: 87991,
    artnr: "065-113",
    category: "Nätverk",
    product_name: "M4250 10G2F - PoE+",
    thumb: "./images/diverse/10g2f.png",
    producer: "Netgear AV Line",
    level: 4,
    description:
    "NETGEAR AV Line M4250-10G2F-PoE+ är en 1 U rackmonterad, administrerad switch utformad för AV över IP-installationer. Den kombinerar åtta PoE+ gigabitportar och två SFP-uplinkar med AV-inriktade profiler och robust multicast-hantering, så att du kan driva enheter, transportera ljud- och videoströmmar och segmentera trafik på ett pålitligt sätt i konferens- eller sceninstallationer.",


    all_lists:[
        {
            list_data:"8 x 1G RJ-45 PoE+",
        },
        {
            list_data:"2 x 1G RJ-45 (Utan PoE)",
        },
        {
            list_data:"125 W PoE budget",
        },
        {
            list_data:"2 x 1G SFP Fiber kontakter",
        },
        {
            list_data:"1 x OOB 1G Ethernet kontakt",
        },
        {
            list_data:"1 x USB-C och 1 x RJ-45 Serial Console kontakter",
        },
    ],
     // technical
    dimension:'440 x 200 x 43 mm',
    vikt_1:'2850 g',
},
{
    id: 87992,
    artnr: "065-114",
    category: "Nätverk",
    product_name: "M4250 26G4XF - PoE+",
    thumb: "./images/diverse/10g2f.png",
    producer: "Netgear AV Line",
    level: 4,
    description:
    "NETGEAR AV Line M4250-26G4XF-PoE+ är en 1 U rackmonterad, administrerad switch utformad för AV över IP-installationer. Den kombinerar 24 st PoE+ gigabitportar och fyra SFP-uplinkar med AV-inriktade profiler och robust multicast-hantering, så att du kan driva enheter, transportera ljud- och videoströmmar och segmentera trafik på ett pålitligt sätt i konferens- eller sceninstallationer.",


    all_lists:[
        {
            list_data:"24 x 1G RJ-45 PoE+",
        },
        {
            list_data:"2 x 1G RJ-45 (Utan PoE)",
        },
        {
            list_data:"300 W PoE budget",
        },
        {
            list_data:"4 x 1G SFP Fiber kontakter",
        },
        {
            list_data:"1 x OOB 1G Ethernet kontakt",
        },
        {
            list_data:"1 x USB-C och 1 x RJ-45 Serial Console kontakter",
        },
    ],
     // technical
    dimension:'440 x 257 x 43 mm',
    vikt_1:'4300 g',
},
// KOMRADIO

// TYGER

]

export default product_img_menu;